import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "area_body" }
const _hoisted_3 = { class: "area_section" }
const _hoisted_4 = { class: "area_form" }
const _hoisted_5 = { class: "area_form_body" }
const _hoisted_6 = { class: "area_row" }
const _hoisted_7 = {
  class: "area_col_row",
  style: {"flex-direction":"row"}
}
const _hoisted_8 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_9 = { class: "area_col_body" }
const _hoisted_10 = { class: "datepicker" }
const _hoisted_11 = {
  class: "area_col",
  style: {"width":"50%"}
}
const _hoisted_12 = { class: "area_col_body" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "area_row" }
const _hoisted_15 = {
  class: "area_col_row",
  style: {"flex-direction":"row"}
}
const _hoisted_16 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_17 = { class: "area_col_body" }
const _hoisted_18 = { class: "select-wrap" }
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  class: "area_col",
  style: {"width":"50%"}
}
const _hoisted_21 = { class: "area_col_body" }
const _hoisted_22 = { class: "select-wrap" }
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: ""
}
const _hoisted_25 = { class: "area_row" }
const _hoisted_26 = {
  class: "area_col_body",
  style: {"position":"relative"}
}
const _hoisted_27 = { class: "area_button" }
const _hoisted_28 = { class: "area_row" }
const _hoisted_29 = { class: "area_col_row area_client" }
const _hoisted_30 = ["textContent"]
const _hoisted_31 = { class: "area_button" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "area_row" }
const _hoisted_34 = { class: "area_col_body" }
const _hoisted_35 = { class: "area_col_row" }
const _hoisted_36 = { class: "area_col" }
const _hoisted_37 = { class: "area_col_body" }
const _hoisted_38 = { class: "checkbox_wrap" }
const _hoisted_39 = ["checked"]
const _hoisted_40 = ["checked"]
const _hoisted_41 = ["checked"]
const _hoisted_42 = ["checked"]
const _hoisted_43 = ["checked"]
const _hoisted_44 = ["checked"]
const _hoisted_45 = ["checked"]
const _hoisted_46 = ["checked"]
const _hoisted_47 = ["checked"]
const _hoisted_48 = ["checked"]
const _hoisted_49 = ["checked"]
const _hoisted_50 = ["checked"]
const _hoisted_51 = ["checked"]
const _hoisted_52 = ["checked"]
const _hoisted_53 = {
  key: 0,
  class: ""
}
const _hoisted_54 = { class: "area_col" }
const _hoisted_55 = { class: "area_col_body full" }
const _hoisted_56 = { class: "area_col" }
const _hoisted_57 = { class: "area_col_body textarea_wrap" }
const _hoisted_58 = { class: "area_row" }
const _hoisted_59 = { class: "area_col_row" }
const _hoisted_60 = { class: "area_col no-line-bottom" }
const _hoisted_61 = { class: "area_col_body" }
const _hoisted_62 = { class: "radio_wrap" }
const _hoisted_63 = ["checked"]
const _hoisted_64 = ["checked"]
const _hoisted_65 = ["checked"]
const _hoisted_66 = ["checked"]
const _hoisted_67 = ["checked"]
const _hoisted_68 = ["checked"]
const _hoisted_69 = ["checked"]
const _hoisted_70 = ["checked"]
const _hoisted_71 = ["checked"]
const _hoisted_72 = { class: "area_col no-line-bottom" }
const _hoisted_73 = { class: "area_col_body" }
const _hoisted_74 = { class: "checkbox_wrap" }
const _hoisted_75 = ["checked"]
const _hoisted_76 = { class: "area_col" }
const _hoisted_77 = { class: "area_col_body" }
const _hoisted_78 = { class: "checkbox_wrap" }
const _hoisted_79 = ["checked"]
const _hoisted_80 = { class: "area_col no-line-bottom" }
const _hoisted_81 = { class: "area_col_body" }
const _hoisted_82 = { class: "checkbox_wrap" }
const _hoisted_83 = ["checked"]
const _hoisted_84 = { class: "area_col no-line-bottom" }
const _hoisted_85 = { class: "area_col_body" }
const _hoisted_86 = { class: "area_col no-line-bottom" }
const _hoisted_87 = { class: "area_col_body" }
const _hoisted_88 = { class: "area_col no-line-bottom" }
const _hoisted_89 = { class: "area_col_body" }
const _hoisted_90 = { class: "area_col no-line-bottom" }
const _hoisted_91 = { class: "area_col_body" }
const _hoisted_92 = { class: "area_col no-line-bottom" }
const _hoisted_93 = { class: "area_col_body" }
const _hoisted_94 = ["textContent"]
const _hoisted_95 = { class: "area_col" }
const _hoisted_96 = { class: "area_col_body" }
const _hoisted_97 = { class: "area_row" }
const _hoisted_98 = { class: "area_col_row" }
const _hoisted_99 = {
  key: 0,
  class: "area_col"
}
const _hoisted_100 = { class: "area_col_body" }
const _hoisted_101 = { class: "area_col_row" }
const _hoisted_102 = { class: "area_col" }
const _hoisted_103 = { class: "area_col_body" }
const _hoisted_104 = { class: "radio_wrap" }
const _hoisted_105 = ["checked"]
const _hoisted_106 = ["checked"]
const _hoisted_107 = ["checked"]
const _hoisted_108 = ["checked"]
const _hoisted_109 = ["checked"]
const _hoisted_110 = ["checked"]
const _hoisted_111 = ["checked"]
const _hoisted_112 = ["checked"]
const _hoisted_113 = ["checked"]
const _hoisted_114 = { key: 0 }
const _hoisted_115 = {
  key: 0,
  class: "area_col no-line-bottom"
}
const _hoisted_116 = { class: "area_col_body" }
const _hoisted_117 = { class: "radio_wrap" }
const _hoisted_118 = ["checked"]
const _hoisted_119 = { class: "radio_wrap" }
const _hoisted_120 = ["checked"]
const _hoisted_121 = { class: "radio_wrap" }
const _hoisted_122 = ["checked"]
const _hoisted_123 = { class: "radio_wrap" }
const _hoisted_124 = ["checked"]
const _hoisted_125 = {
  key: 1,
  class: "area_col no-line-bottom"
}
const _hoisted_126 = { class: "area_col_body" }
const _hoisted_127 = { class: "radio_wrap" }
const _hoisted_128 = ["checked", "disabled"]
const _hoisted_129 = { class: "radio_wrap" }
const _hoisted_130 = ["checked"]
const _hoisted_131 = {
  key: 0,
  class: "radio_wrap"
}
const _hoisted_132 = ["checked", "disabled"]
const _hoisted_133 = {
  key: 2,
  class: "area_col"
}
const _hoisted_134 = { class: "area_col_body" }
const _hoisted_135 = { class: "radio_wrap" }
const _hoisted_136 = ["checked"]
const _hoisted_137 = { key: 0 }
const _hoisted_138 = { key: 1 }
const _hoisted_139 = { class: "radio_wrap" }
const _hoisted_140 = ["checked"]
const _hoisted_141 = { class: "radio_wrap" }
const _hoisted_142 = ["checked"]
const _hoisted_143 = { class: "radio_wrap" }
const _hoisted_144 = ["checked"]
const _hoisted_145 = { class: "radio_wrap" }
const _hoisted_146 = ["checked"]
const _hoisted_147 = { class: "radio_wrap" }
const _hoisted_148 = ["checked"]
const _hoisted_149 = { class: "radio_wrap" }
const _hoisted_150 = ["checked"]
const _hoisted_151 = { class: "radio_wrap" }
const _hoisted_152 = ["checked"]
const _hoisted_153 = { class: "radio_wrap" }
const _hoisted_154 = ["checked"]
const _hoisted_155 = { class: "radio_wrap" }
const _hoisted_156 = ["checked"]
const _hoisted_157 = { class: "radio_wrap" }
const _hoisted_158 = ["checked"]
const _hoisted_159 = { class: "radio_wrap" }
const _hoisted_160 = ["checked"]
const _hoisted_161 = { class: "radio_wrap" }
const _hoisted_162 = ["checked"]
const _hoisted_163 = { class: "radio_wrap" }
const _hoisted_164 = ["checked"]
const _hoisted_165 = { class: "radio_wrap" }
const _hoisted_166 = ["checked"]
const _hoisted_167 = { class: "radio_wrap" }
const _hoisted_168 = ["checked"]
const _hoisted_169 = { class: "radio_wrap" }
const _hoisted_170 = ["checked"]
const _hoisted_171 = { class: "radio_wrap" }
const _hoisted_172 = ["checked"]
const _hoisted_173 = { class: "radio_wrap" }
const _hoisted_174 = ["checked"]
const _hoisted_175 = { class: "radio_wrap" }
const _hoisted_176 = ["checked"]
const _hoisted_177 = { class: "radio_wrap" }
const _hoisted_178 = ["checked"]
const _hoisted_179 = { key: 0 }
const _hoisted_180 = {
  key: 1,
  class: "area_col"
}
const _hoisted_181 = { class: "area_col_body no_padding" }
const _hoisted_182 = { class: "area_col_row" }
const _hoisted_183 = { class: "form_list_wrap" }
const _hoisted_184 = { class: "form_list" }
const _hoisted_185 = { class: "flex wrap" }
const _hoisted_186 = { class: "radio_wrap" }
const _hoisted_187 = ["checked"]
const _hoisted_188 = ["checked"]
const _hoisted_189 = ["checked"]
const _hoisted_190 = ["checked"]
const _hoisted_191 = ["checked"]
const _hoisted_192 = ["checked"]
const _hoisted_193 = ["checked"]
const _hoisted_194 = ["checked"]
const _hoisted_195 = ["checked"]
const _hoisted_196 = ["checked"]
const _hoisted_197 = { key: 0 }
const _hoisted_198 = { key: 0 }
const _hoisted_199 = { class: "flex ac" }
const _hoisted_200 = {
  key: 0,
  class: "form_list"
}
const _hoisted_201 = { class: "flex wrap" }
const _hoisted_202 = { class: "radio_wrap" }
const _hoisted_203 = ["checked"]
const _hoisted_204 = { class: "radio_wrap" }
const _hoisted_205 = ["checked"]
const _hoisted_206 = { class: "radio_wrap" }
const _hoisted_207 = ["checked"]
const _hoisted_208 = { class: "radio_wrap" }
const _hoisted_209 = ["checked"]
const _hoisted_210 = { class: "form_list" }
const _hoisted_211 = { class: "flex wrap" }
const _hoisted_212 = { class: "radio_wrap" }
const _hoisted_213 = ["checked"]
const _hoisted_214 = { key: 0 }
const _hoisted_215 = { key: 1 }
const _hoisted_216 = { class: "form_list" }
const _hoisted_217 = { class: "flex wrap" }
const _hoisted_218 = { class: "radio_wrap" }
const _hoisted_219 = ["checked"]
const _hoisted_220 = {
  key: 2,
  class: "area_col"
}
const _hoisted_221 = { class: "area_col_body" }
const _hoisted_222 = { class: "area_col_row" }
const _hoisted_223 = { class: "area_col" }
const _hoisted_224 = { class: "area_col_body" }
const _hoisted_225 = { class: "radio_wrap" }
const _hoisted_226 = ["checked"]
const _hoisted_227 = ["checked"]
const _hoisted_228 = ["checked"]
const _hoisted_229 = ["checked"]
const _hoisted_230 = ["checked"]
const _hoisted_231 = ["checked"]
const _hoisted_232 = {
  key: 0,
  class: "area_col"
}
const _hoisted_233 = { class: "area_col_body" }
const _hoisted_234 = { class: "radio_wrap" }
const _hoisted_235 = ["checked"]
const _hoisted_236 = ["checked"]
const _hoisted_237 = ["checked"]
const _hoisted_238 = ["checked"]
const _hoisted_239 = ["checked"]
const _hoisted_240 = ["checked"]
const _hoisted_241 = ["checked"]
const _hoisted_242 = { key: 0 }
const _hoisted_243 = {
  key: 3,
  class: "area_col"
}
const _hoisted_244 = { class: "area_col_body" }
const _hoisted_245 = { class: "area_col_row" }
const _hoisted_246 = { class: "area_col" }
const _hoisted_247 = { class: "area_col_body" }
const _hoisted_248 = { class: "radio_wrap" }
const _hoisted_249 = ["checked"]
const _hoisted_250 = ["checked"]
const _hoisted_251 = ["checked"]
const _hoisted_252 = ["checked"]
const _hoisted_253 = ["checked"]
const _hoisted_254 = {
  key: 4,
  class: "area_col"
}
const _hoisted_255 = { class: "area_col_body" }
const _hoisted_256 = { class: "area_col_row" }
const _hoisted_257 = { class: "area_col" }
const _hoisted_258 = { class: "area_col_body" }
const _hoisted_259 = { class: "radio_wrap" }
const _hoisted_260 = ["checked"]
const _hoisted_261 = ["checked"]
const _hoisted_262 = ["checked"]
const _hoisted_263 = ["checked"]
const _hoisted_264 = ["checked"]
const _hoisted_265 = ["checked"]
const _hoisted_266 = { key: 0 }
const _hoisted_267 = {
  key: 0,
  class: "area_col"
}
const _hoisted_268 = { class: "area_col_body" }
const _hoisted_269 = { class: "radio_wrap" }
const _hoisted_270 = ["checked"]
const _hoisted_271 = ["checked"]
const _hoisted_272 = ["checked"]
const _hoisted_273 = {
  key: 5,
  class: "area_col"
}
const _hoisted_274 = { class: "area_col_body" }
const _hoisted_275 = { class: "area_col_row" }
const _hoisted_276 = { class: "area_col no-line-bottom" }
const _hoisted_277 = { class: "area_col_body" }
const _hoisted_278 = { class: "radio_wrap" }
const _hoisted_279 = ["checked"]
const _hoisted_280 = ["checked"]
const _hoisted_281 = {
  key: 6,
  class: "area_col"
}
const _hoisted_282 = { class: "area_col_body" }
const _hoisted_283 = { class: "area_col_row" }
const _hoisted_284 = { class: "area_col" }
const _hoisted_285 = { class: "area_col_body" }
const _hoisted_286 = { class: "radio_wrap" }
const _hoisted_287 = ["checked"]
const _hoisted_288 = ["checked"]
const _hoisted_289 = {
  key: 7,
  class: "area_col"
}
const _hoisted_290 = { class: "area_col_body" }
const _hoisted_291 = { class: "area_col_row" }
const _hoisted_292 = { class: "area_col" }
const _hoisted_293 = { class: "area_col_body" }
const _hoisted_294 = { class: "radio_wrap" }
const _hoisted_295 = ["checked"]
const _hoisted_296 = ["checked"]
const _hoisted_297 = ["checked"]
const _hoisted_298 = {
  key: 8,
  class: "area_col"
}
const _hoisted_299 = { class: "area_col_body" }
const _hoisted_300 = { class: "area_col_row" }
const _hoisted_301 = { class: "area_col" }
const _hoisted_302 = { class: "area_col_body" }
const _hoisted_303 = { class: "radio_wrap" }
const _hoisted_304 = ["checked"]
const _hoisted_305 = ["checked"]
const _hoisted_306 = ["checked"]
const _hoisted_307 = ["checked"]
const _hoisted_308 = ["checked"]
const _hoisted_309 = ["checked"]
const _hoisted_310 = ["checked"]
const _hoisted_311 = ["checked"]
const _hoisted_312 = ["checked"]
const _hoisted_313 = {
  key: 0,
  class: ""
}
const _hoisted_314 = {
  key: 0,
  class: "area_col"
}
const _hoisted_315 = { class: "area_col_body" }
const _hoisted_316 = { class: "radio_wrap" }
const _hoisted_317 = ["checked"]
const _hoisted_318 = ["checked"]
const _hoisted_319 = ["checked"]
const _hoisted_320 = ["checked"]
const _hoisted_321 = ["checked"]
const _hoisted_322 = { class: "area_col" }
const _hoisted_323 = { class: "area_col_body" }
const _hoisted_324 = { class: "radio_wrap" }
const _hoisted_325 = ["checked"]
const _hoisted_326 = ["checked"]
const _hoisted_327 = ["checked"]
const _hoisted_328 = ["checked"]
const _hoisted_329 = {
  key: 9,
  class: "area_col no-line-bottom"
}
const _hoisted_330 = { class: "area_col_body" }
const _hoisted_331 = { class: "area_col_row" }
const _hoisted_332 = { class: "area_col" }
const _hoisted_333 = { class: "area_col_body" }
const _hoisted_334 = { class: "radio_wrap" }
const _hoisted_335 = ["checked"]
const _hoisted_336 = ["checked"]
const _hoisted_337 = ["checked"]
const _hoisted_338 = ["checked"]
const _hoisted_339 = ["checked"]
const _hoisted_340 = { class: "area_row" }
const _hoisted_341 = { class: "area_col_row" }
const _hoisted_342 = { class: "area_col" }
const _hoisted_343 = { class: "area_col_body" }
const _hoisted_344 = { class: "checkbox_wrap" }
const _hoisted_345 = ["checked"]
const _hoisted_346 = { class: "area_col" }
const _hoisted_347 = { class: "area_col_body" }
const _hoisted_348 = { class: "checkbox_wrap" }
const _hoisted_349 = ["checked"]
const _hoisted_350 = { class: "checkbox_wrap" }
const _hoisted_351 = ["checked"]
const _hoisted_352 = { class: "checkbox_wrap" }
const _hoisted_353 = ["checked"]
const _hoisted_354 = { class: "area_col" }
const _hoisted_355 = { class: "area_col_body" }
const _hoisted_356 = { class: "checkbox_wrap" }
const _hoisted_357 = ["checked"]
const _hoisted_358 = { class: "checkbox_wrap" }
const _hoisted_359 = ["checked"]
const _hoisted_360 = { class: "checkbox_wrap" }
const _hoisted_361 = ["checked"]
const _hoisted_362 = { class: "checkbox_wrap" }
const _hoisted_363 = ["checked"]
const _hoisted_364 = { class: "checkbox_wrap" }
const _hoisted_365 = ["checked"]
const _hoisted_366 = { class: "checkbox_wrap" }
const _hoisted_367 = ["checked"]
const _hoisted_368 = { class: "area_col no-line-bottom" }
const _hoisted_369 = { class: "area_col_body" }
const _hoisted_370 = { class: "area_col_row" }
const _hoisted_371 = { class: "area_col" }
const _hoisted_372 = { class: "area_col_body" }
const _hoisted_373 = { class: "checkbox_wrap" }
const _hoisted_374 = ["checked"]
const _hoisted_375 = ["checked"]
const _hoisted_376 = ["checked"]
const _hoisted_377 = ["checked"]
const _hoisted_378 = ["checked"]
const _hoisted_379 = ["checked"]
const _hoisted_380 = ["checked"]
const _hoisted_381 = ["checked"]
const _hoisted_382 = ["checked"]
const _hoisted_383 = ["checked"]
const _hoisted_384 = ["checked"]
const _hoisted_385 = { key: 0 }
const _hoisted_386 = { class: "area_col" }
const _hoisted_387 = { class: "area_col_body" }
const _hoisted_388 = { class: "checkbox_wrap" }
const _hoisted_389 = ["checked"]
const _hoisted_390 = ["checked"]
const _hoisted_391 = ["checked"]
const _hoisted_392 = ["checked"]
const _hoisted_393 = ["checked"]
const _hoisted_394 = { key: 0 }
const _hoisted_395 = { class: "area_row" }
const _hoisted_396 = { class: "area_col_body textarea_wrap" }
const _hoisted_397 = { class: "area_section" }
const _hoisted_398 = { class: "area_form_foot" }
const _hoisted_399 = { class: "area_button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_FindClient = _resolveComponent("FindClient")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[602] || (_cache[602] = _createElementVNode("div", { class: "area_form_title" }, [
                _createElementVNode("p", null, "상담내용")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[200] || (_cache[200] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "1. 작성일")
                      ], -1)),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.data.date) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.state.data.date]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[201] || (_cache[201] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "2. 작성자")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.data.csmName) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.state.data.csmName]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[203] || (_cache[203] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "3. 상담유형")
                      ], -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.data.cstype) = $event))
                          }, [
                            _cache[202] || (_cache[202] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.counselTypeListForCounsel, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.key
                              }, _toDisplayString(item.name), 9, _hoisted_19))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, $setup.state.data.cstype]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[205] || (_cache[205] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "4. 상담 대상자")
                      ], -1)),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.data.csperson) = $event))
                          }, [
                            _cache[204] || (_cache[204] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.personTargetList, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.key
                              }, _toDisplayString(item.name), 9, _hoisted_23))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, $setup.state.data.csperson]
                          ])
                        ]),
                        ($setup.state.data.csperson === '기타')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.data.cspersonEtc) = $event))
                              }, null, 512), [
                                [_vModelText, $setup.state.data.cspersonEtc]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[207] || (_cache[207] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "4-1. 내담자 검색")
                  ], -1)),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.state.isShowFindClient = true))
                      }, _cache[206] || (_cache[206] = [
                        _createElementVNode("span", null, "검색", -1)
                      ]))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[209] || (_cache[209] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "4-2. 등록된 내담자")
                  ], -1)),
                  _createElementVNode("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.listForSearch, (item, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "area_col no-line-bottom",
                        key: key
                      }, [
                        _cache[208] || (_cache[208] = _createElementVNode("img", { src: "img/icon_client.png" }, null, -1)),
                        _createElementVNode("p", {
                          textContent: _toDisplayString(item.vstNo)
                        }, null, 8, _hoisted_30),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => ($setup.state.listForSearch.splice(key, 1))
                          }, "삭제", 8, _hoisted_32)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[241] || (_cache[241] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "5. 상담내용")
                  ], -1)),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _cache[238] || (_cache[238] = _createElementVNode("div", { class: "area_col" }, [
                        _createElementVNode("div", { class: "area_col_body" }, [
                          _createElementVNode("label", null, "[5-1. 상담내용유형]")
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeSale === 1,
                                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.state.data.cktypeSale ^= 1))
                              }, null, 8, _hoisted_39),
                              _cache[210] || (_cache[210] = _createElementVNode("em", null, null, -1)),
                              _cache[211] || (_cache[211] = _createElementVNode("span", null, "탈성매매", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeDept === 1,
                                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.state.data.cktypeDept ^= 1))
                              }, null, 8, _hoisted_40),
                              _cache[212] || (_cache[212] = _createElementVNode("em", null, null, -1)),
                              _cache[213] || (_cache[213] = _createElementVNode("span", null, "빚문제", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeForce === 1,
                                onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.state.data.cktypeForce ^= 1))
                              }, null, 8, _hoisted_41),
                              _cache[214] || (_cache[214] = _createElementVNode("em", null, null, -1)),
                              _cache[215] || (_cache[215] = _createElementVNode("span", null, "폭행", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeCareer === 1,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.state.data.cktypeCareer ^= 1))
                              }, null, 8, _hoisted_42),
                              _cache[216] || (_cache[216] = _createElementVNode("em", null, null, -1)),
                              _cache[217] || (_cache[217] = _createElementVNode("span", null, "진로(취업 등)", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeBrand === 1,
                                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.state.data.cktypeBrand ^= 1))
                              }, null, 8, _hoisted_43),
                              _cache[218] || (_cache[218] = _createElementVNode("em", null, null, -1)),
                              _cache[219] || (_cache[219] = _createElementVNode("span", null, "사회적 낙인", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeHealth === 1,
                                onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.state.data.cktypeHealth ^= 1))
                              }, null, 8, _hoisted_44),
                              _cache[220] || (_cache[220] = _createElementVNode("em", null, null, -1)),
                              _cache[221] || (_cache[221] = _createElementVNode("span", null, "건강의료 문제", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypePolice === 1,
                                onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.state.data.cktypePolice ^= 1))
                              }, null, 8, _hoisted_45),
                              _cache[222] || (_cache[222] = _createElementVNode("em", null, null, -1)),
                              _cache[223] || (_cache[223] = _createElementVNode("span", null, "경찰조사", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeLaw === 1,
                                onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.state.data.cktypeLaw ^= 1))
                              }, null, 8, _hoisted_46),
                              _cache[224] || (_cache[224] = _createElementVNode("em", null, null, -1)),
                              _cache[225] || (_cache[225] = _createElementVNode("span", null, "법률문제", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeFamily === 1,
                                onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.state.data.cktypeFamily ^= 1))
                              }, null, 8, _hoisted_47),
                              _cache[226] || (_cache[226] = _createElementVNode("em", null, null, -1)),
                              _cache[227] || (_cache[227] = _createElementVNode("span", null, "가족문제", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeHome === 1,
                                onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.state.data.cktypeHome ^= 1))
                              }, null, 8, _hoisted_48),
                              _cache[228] || (_cache[228] = _createElementVNode("em", null, null, -1)),
                              _cache[229] || (_cache[229] = _createElementVNode("span", null, "주거", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeProblem === 1,
                                onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.state.data.cktypeProblem ^= 1))
                              }, null, 8, _hoisted_49),
                              _cache[230] || (_cache[230] = _createElementVNode("em", null, null, -1)),
                              _cache[231] || (_cache[231] = _createElementVNode("span", null, "자활문제", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeEmotional === 1,
                                onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.state.data.cktypeEmotional ^= 1))
                              }, null, 8, _hoisted_50),
                              _cache[232] || (_cache[232] = _createElementVNode("em", null, null, -1)),
                              _cache[233] || (_cache[233] = _createElementVNode("span", null, "정서문제", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypePg === 1,
                                onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.state.data.cktypePg ^= 1))
                              }, null, 8, _hoisted_51),
                              _cache[234] || (_cache[234] = _createElementVNode("em", null, null, -1)),
                              _cache[235] || (_cache[235] = _createElementVNode("span", null, "사각지대PG", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.state.data.cktypeEtc === 1,
                                onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.state.data.cktypeEtc ^= 1))
                              }, null, 8, _hoisted_52),
                              _cache[236] || (_cache[236] = _createElementVNode("em", null, null, -1)),
                              _cache[237] || (_cache[237] = _createElementVNode("span", null, "기타", -1))
                            ])
                          ]),
                          ($setup.state.data.cktypeEtc === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.state.data.cktypeEtcText) = $event))
                                }, null, 512), [
                                  [_vModelText, $setup.state.data.cktypeEtcText]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _cache[239] || (_cache[239] = _createElementVNode("div", { class: "area_col" }, [
                        _createElementVNode("div", { class: "area_col_body" }, [
                          _createElementVNode("label", null, "[5-2. 상담제목]")
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.state.data.title) = $event)),
                            placeholder: "상담 제목을 입력해주세요."
                          }, null, 512), [
                            [_vModelText, $setup.state.data.title]
                          ])
                        ])
                      ]),
                      _cache[240] || (_cache[240] = _createElementVNode("div", { class: "area_col" }, [
                        _createElementVNode("div", { class: "area_col_body" }, [
                          _createElementVNode("label", null, "[5-3. 상담내용]")
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.state.data.counselDetailVO.processsts) = $event)),
                            placeholder: "상담 내용을 입력해주세요."
                          }, null, 512), [
                            [_vModelText, $setup.state.data.counselDetailVO.processsts]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _cache[292] || (_cache[292] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "6. 상담조치결과")
                  ], -1)),
                  _createElementVNode("div", _hoisted_59, [
                    _cache[290] || (_cache[290] = _createElementVNode("div", { class: "area_col no-line-bottom" }, [
                      _createElementVNode("div", { class: "area_col_body" }, [
                        _createElementVNode("label", { class: "starMark" }, "지원 구분")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "result",
                              checked: $setup.state.data.result === '정서적지원',
                              onClick: _cache[23] || (_cache[23] = ($event: any) => {
                                                            $setup.state.data.result = '정서적지원';
                                                            $setup.state.data.newInterventionMethod = '';
                                                        })
                            }, null, 8, _hoisted_63),
                            _cache[242] || (_cache[242] = _createElementVNode("em", null, null, -1)),
                            _cache[243] || (_cache[243] = _createElementVNode("span", null, "정서적지원", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "result",
                              checked: $setup.state.data.result === '법률지원',
                              onClick: _cache[24] || (_cache[24] = ($event: any) => {
                                                            $setup.state.data.result = '법률지원';
                                                            $setup.state.data.newInterventionMethod = '';
                                                        })
                            }, null, 8, _hoisted_64),
                            _cache[244] || (_cache[244] = _createElementVNode("em", null, null, -1)),
                            _cache[245] || (_cache[245] = _createElementVNode("span", null, "법률지원", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "result",
                              checked: $setup.state.data.result === '의료지원',
                              onClick: _cache[25] || (_cache[25] = ($event: any) => {
                                                            $setup.state.data.result = '의료지원';
                                                            $setup.state.data.newInterventionMethod = '';
                                                        })
                            }, null, 8, _hoisted_65),
                            _cache[246] || (_cache[246] = _createElementVNode("em", null, null, -1)),
                            _cache[247] || (_cache[247] = _createElementVNode("span", null, "의료지원", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "result",
                              checked: $setup.state.data.result === '자활지원',
                              onClick: _cache[26] || (_cache[26] = ($event: any) => {
                                                            $setup.state.data.result = '자활지원';
                                                            $setup.state.data.newInterventionMethod = '';
                                                        })
                            }, null, 8, _hoisted_66),
                            _cache[248] || (_cache[248] = _createElementVNode("em", null, null, -1)),
                            _cache[249] || (_cache[249] = _createElementVNode("span", null, "자활지원", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "result",
                              checked: $setup.state.data.result === '집단프로그램',
                              onClick: _cache[27] || (_cache[27] = ($event: any) => {
                                                            $setup.state.data.result = '집단프로그램';
                                                            $setup.state.data.newInterventionMethod = '';
                                                        })
                            }, null, 8, _hoisted_67),
                            _cache[250] || (_cache[250] = _createElementVNode("em", null, null, -1)),
                            _cache[251] || (_cache[251] = _createElementVNode("span", null, "집단프로그램", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "result",
                              checked: $setup.state.data.result === '물적자원',
                              onClick: _cache[28] || (_cache[28] = ($event: any) => {
                                                            $setup.state.data.result = '물적자원';
                                                            $setup.state.data.newInterventionMethod = '';
                                                        })
                            }, null, 8, _hoisted_68),
                            _cache[252] || (_cache[252] = _createElementVNode("em", null, null, -1)),
                            _cache[253] || (_cache[253] = _createElementVNode("span", null, "물적자원", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "result",
                              checked: $setup.state.data.result === '심리지원',
                              onClick: _cache[29] || (_cache[29] = ($event: any) => {
                                                            $setup.state.data.result = '심리지원';
                                                            $setup.state.data.newInterventionMethod = '';
                                                        })
                            }, null, 8, _hoisted_69),
                            _cache[254] || (_cache[254] = _createElementVNode("em", null, null, -1)),
                            _cache[255] || (_cache[255] = _createElementVNode("span", null, "심리지원", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "result",
                              checked: $setup.state.data.result === '관련기관연계',
                              onClick: _cache[30] || (_cache[30] = ($event: any) => {
                                                            $setup.state.data.result = '관련기관연계';
                                                            $setup.state.data.newInterventionMethod = '';
                                                        })
                            }, null, 8, _hoisted_70),
                            _cache[256] || (_cache[256] = _createElementVNode("em", null, null, -1)),
                            _cache[257] || (_cache[257] = _createElementVNode("span", null, "관련기관연계", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "result",
                              checked: $setup.state.data.result === '기타',
                              onClick: _cache[31] || (_cache[31] = ($event: any) => {
                                                            $setup.state.data.result = '기타';
                                                            $setup.state.data.newInterventionMethod = '';
                                                        })
                            }, null, 8, _hoisted_71),
                            _cache[258] || (_cache[258] = _createElementVNode("em", null, null, -1)),
                            _cache[259] || (_cache[259] = _createElementVNode("span", null, "기타", -1))
                          ])
                        ])
                      ])
                    ]),
                    _cache[291] || (_cache[291] = _createElementVNode("div", { class: "area_col no-line-bottom" }, [
                      _createElementVNode("div", { class: "area_col_body" }, [
                        _createElementVNode("p", null, "※ 2019년 7월 4일 수정 이전 개입방법:")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSupportingExpenseYn === 1,
                              onClick: _cache[32] || (_cache[32] = ($event: any) => ($setup.state.data.newSupportingExpenseYn ^= 1))
                            }, null, 8, _hoisted_75),
                            _cache[260] || (_cache[260] = _createElementVNode("em", null, null, -1)),
                            _cache[261] || (_cache[261] = _createElementVNode("span", null, "구조지원비 사용", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _cache[262] || (_cache[262] = _createTextVNode(" (비용 ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.state.data.newSupportingExpensePrice) = $event))
                            }, null, 512), [
                              [_vModelText, $setup.state.data.newSupportingExpensePrice]
                            ]),
                            _cache[263] || (_cache[263] = _createTextVNode(" 원 ", -1)),
                            _cache[264] || (_cache[264] = _createElementVNode("span", { style: {"color":"#4d60b3"} }, null, -1)),
                            _cache[265] || (_cache[265] = _createTextVNode(" ) ", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSupportingIncreaseYn === 1,
                              onClick: _cache[34] || (_cache[34] = ($event: any) => ($setup.state.data.newSupportingIncreaseYn ^= 1))
                            }, null, 8, _hoisted_79),
                            _cache[266] || (_cache[266] = _createElementVNode("em", null, null, -1)),
                            _cache[267] || (_cache[267] = _createElementVNode("span", null, "구조지원비 증액", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _cache[268] || (_cache[268] = _createTextVNode(" (비용 ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.state.data.newSupportingIncreasePrice) = $event))
                            }, null, 512), [
                              [_vModelText, $setup.state.data.newSupportingIncreasePrice]
                            ]),
                            _cache[269] || (_cache[269] = _createTextVNode(" 원 ", -1)),
                            _cache[270] || (_cache[270] = _createElementVNode("span", { style: {"color":"#4d60b3"} }, null, -1)),
                            _cache[271] || (_cache[271] = _createTextVNode(" ) ", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newPrevSupportingExpense === 1,
                              onClick: _cache[36] || (_cache[36] = ($event: any) => ($setup.state.data.newPrevSupportingExpense ^= 1))
                            }, null, 8, _hoisted_83),
                            _cache[272] || (_cache[272] = _createElementVNode("em", null, null, -1)),
                            _cache[273] || (_cache[273] = _createElementVNode("span", null, "구조지원비 통계 미반영", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", null, [
                            _cache[274] || (_cache[274] = _createTextVNode(" 이전 의료지원 총 비용 : ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.state.data.newPrevMedicalPrice) = $event))
                            }, null, 512), [
                              [_vModelText, $setup.state.data.newPrevMedicalPrice]
                            ]),
                            _cache[275] || (_cache[275] = _createTextVNode(" 원 ", -1)),
                            _cache[276] || (_cache[276] = _createElementVNode("span", { style: {"color":"#4d60b3"} }, null, -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", null, [
                            _cache[277] || (_cache[277] = _createTextVNode(" 이전 법률지원 총 비용 ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.state.data.newPrevLawPrice) = $event))
                            }, null, 512), [
                              [_vModelText, $setup.state.data.newPrevLawPrice]
                            ]),
                            _cache[278] || (_cache[278] = _createTextVNode(" 원 ", -1)),
                            _cache[279] || (_cache[279] = _createElementVNode("span", { style: {"color":"#4d60b3"} }, null, -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", null, [
                            _cache[280] || (_cache[280] = _createTextVNode(" 이전 직업훈련 총 비용 ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.state.data.newPrevJobTrainingPrice) = $event))
                            }, null, 512), [
                              [_vModelText, $setup.state.data.newPrevJobTrainingPrice]
                            ]),
                            _cache[281] || (_cache[281] = _createTextVNode(" 원 ", -1)),
                            _cache[282] || (_cache[282] = _createElementVNode("span", { style: {"color":"#4d60b3"} }, null, -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", null, [
                            _cache[283] || (_cache[283] = _createTextVNode(" 이전 미파악 총 비용 ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.state.data.newPrevNotGraspPrice) = $event))
                            }, null, 512), [
                              [_vModelText, $setup.state.data.newPrevNotGraspPrice]
                            ]),
                            _cache[284] || (_cache[284] = _createTextVNode(" 원 ", -1)),
                            _cache[285] || (_cache[285] = _createElementVNode("span", { style: {"color":"#4d60b3"} }, null, -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", null, [
                            _cache[286] || (_cache[286] = _createTextVNode(" 이전 의료지원 총 비용 ", -1)),
                            _createElementVNode("span", {
                              textContent: _toDisplayString(
                                                            $setup.CommonUtils.numberFormat(
                                                                Number($setup.state.data.newPrevMedicalPrice ?? 0) +
                                                                    Number($setup.state.data.newPrevLawPrice ?? 0) +
                                                                    Number($setup.state.data.newPrevJobTrainingPrice ?? 0) +
                                                                    Number($setup.state.data.newPrevNotGraspPrice ?? 0),
                                                            )
                                                        )
                            }, null, 8, _hoisted_94),
                            _cache[287] || (_cache[287] = _createTextVNode(" 원 ", -1)),
                            _cache[288] || (_cache[288] = _createElementVNode("span", { style: {"color":"#4d60b3"} }, null, -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", null, [
                            _cache[289] || (_cache[289] = _createTextVNode(" 이전 기관명 ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.state.data.newPrevInstitution) = $event))
                            }, null, 512), [
                              [_vModelText, $setup.state.data.newPrevInstitution]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _cache[542] || (_cache[542] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "7. 개입방법")
                  ], -1)),
                  _createElementVNode("div", _hoisted_98, [
                    ($setup.state.data.result === '법률지원')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                          _cache[371] || (_cache[371] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "법률지원")
                          ], -1)),
                          _createElementVNode("div", _hoisted_100, [
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("div", _hoisted_102, [
                                _cache[311] || (_cache[311] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[법률지원]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_103, [
                                  _createElementVNode("div", _hoisted_104, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '법률상담',
                                        onClick: _cache[42] || (_cache[42] = ($event: any) => ($setup.state.data.newInterventionMethod = '법률상담'))
                                      }, null, 8, _hoisted_105),
                                      _cache[293] || (_cache[293] = _createElementVNode("em", null, null, -1)),
                                      _cache[294] || (_cache[294] = _createElementVNode("span", null, "법률상담", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '수사동행(경찰)',
                                        onClick: _cache[43] || (_cache[43] = ($event: any) => ($setup.state.data.newInterventionMethod = '수사동행(경찰)'))
                                      }, null, 8, _hoisted_106),
                                      _cache[295] || (_cache[295] = _createElementVNode("em", null, null, -1)),
                                      _cache[296] || (_cache[296] = _createElementVNode("span", null, "수사동행(경찰)", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '수사동행(검찰)',
                                        onClick: _cache[44] || (_cache[44] = ($event: any) => ($setup.state.data.newInterventionMethod = '수사동행(검찰)'))
                                      }, null, 8, _hoisted_107),
                                      _cache[297] || (_cache[297] = _createElementVNode("em", null, null, -1)),
                                      _cache[298] || (_cache[298] = _createElementVNode("span", null, "수사동행(검찰)", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '수사의뢰',
                                        onClick: _cache[45] || (_cache[45] = ($event: any) => ($setup.state.data.newInterventionMethod = '수사의뢰'))
                                      }, null, 8, _hoisted_108),
                                      _cache[299] || (_cache[299] = _createElementVNode("em", null, null, -1)),
                                      _cache[300] || (_cache[300] = _createElementVNode("span", null, "수사의뢰", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '현장구조',
                                        onClick: _cache[46] || (_cache[46] = ($event: any) => ($setup.state.data.newInterventionMethod = '현장구조'))
                                      }, null, 8, _hoisted_109),
                                      _cache[301] || (_cache[301] = _createElementVNode("em", null, null, -1)),
                                      _cache[302] || (_cache[302] = _createElementVNode("span", null, "현장구조", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '소년보호',
                                        onClick: _cache[47] || (_cache[47] = ($event: any) => ($setup.state.data.newInterventionMethod = '소년보호'))
                                      }, null, 8, _hoisted_110),
                                      _cache[303] || (_cache[303] = _createElementVNode("em", null, null, -1)),
                                      _cache[304] || (_cache[304] = _createElementVNode("span", null, "소년보호", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '수사지원',
                                        onClick: _cache[48] || (_cache[48] = ($event: any) => ($setup.state.data.newInterventionMethod = '수사지원'))
                                      }, null, 8, _hoisted_111),
                                      _cache[305] || (_cache[305] = _createElementVNode("em", null, null, -1)),
                                      _cache[306] || (_cache[306] = _createElementVNode("span", null, "수사지원", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '소송지원',
                                        onClick: _cache[49] || (_cache[49] = ($event: any) => ($setup.state.data.newInterventionMethod = '소송지원'))
                                      }, null, 8, _hoisted_112),
                                      _cache[307] || (_cache[307] = _createElementVNode("em", null, null, -1)),
                                      _cache[308] || (_cache[308] = _createElementVNode("span", null, "소송지원", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '개입방법/법률지원/기타',
                                        onClick: _cache[50] || (_cache[50] = ($event: any) => ($setup.state.data.newInterventionMethod = '개입방법/법률지원/기타'))
                                      }, null, 8, _hoisted_113),
                                      _cache[309] || (_cache[309] = _createElementVNode("em", null, null, -1)),
                                      _cache[310] || (_cache[310] = _createElementVNode("span", null, "기타", -1))
                                    ])
                                  ]),
                                  ($setup.state.data.newInterventionMethod === '개입방법/법률지원/기타')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (($setup.state.data.newInterventionMethodTxt3) = $event))
                                        }, null, 512), [
                                          [_vModelText, $setup.state.data.newInterventionMethodTxt3]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              ($setup.state.data.newInterventionMethod === '소송지원')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                    _cache[320] || (_cache[320] = _createElementVNode("div", { class: "area_col_head" }, "[소송지원]", -1)),
                                    _createElementVNode("div", _hoisted_116, [
                                      _createElementVNode("div", _hoisted_117, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw0",
                                            checked: $setup.state.data.newInterventionMethodLaw0 === '민사',
                                            onClick: _cache[52] || (_cache[52] = ($event: any) => {
                                                                        $setup.state.data.newInterventionMethodLaw0 = '민사';
                                                                        $setup.state.data.newInterventionMethodLaw1 = '';
                                                                    })
                                          }, null, 8, _hoisted_118),
                                          _cache[312] || (_cache[312] = _createElementVNode("em", null, null, -1)),
                                          _cache[313] || (_cache[313] = _createElementVNode("span", null, "민사", -1))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_119, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw0",
                                            checked: $setup.state.data.newInterventionMethodLaw0 === '형사',
                                            onClick: _cache[53] || (_cache[53] = ($event: any) => {
                                                                        $setup.state.data.newInterventionMethodLaw0 = '형사';
                                                                        $setup.state.data.newInterventionMethodLaw1 = '';
                                                                    })
                                          }, null, 8, _hoisted_120),
                                          _cache[314] || (_cache[314] = _createElementVNode("em", null, null, -1)),
                                          _cache[315] || (_cache[315] = _createElementVNode("span", null, "형사", -1))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_121, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw0",
                                            checked: $setup.state.data.newInterventionMethodLaw0 === '가사',
                                            onClick: _cache[54] || (_cache[54] = ($event: any) => {
                                                                        $setup.state.data.newInterventionMethodLaw0 = '가사';
                                                                        $setup.state.data.newInterventionMethodLaw1 = '';
                                                                    })
                                          }, null, 8, _hoisted_122),
                                          _cache[316] || (_cache[316] = _createElementVNode("em", null, null, -1)),
                                          _cache[317] || (_cache[317] = _createElementVNode("span", null, "가사", -1))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_123, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw0",
                                            checked: $setup.state.data.newInterventionMethodLaw0 === '행정',
                                            onClick: _cache[55] || (_cache[55] = ($event: any) => {
                                                                        $setup.state.data.newInterventionMethodLaw0 = '행정';
                                                                        $setup.state.data.newInterventionMethodLaw1 = '';
                                                                    })
                                          }, null, 8, _hoisted_124),
                                          _cache[318] || (_cache[318] = _createElementVNode("em", null, null, -1)),
                                          _cache[319] || (_cache[319] = _createElementVNode("span", null, "행정", -1))
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                                                        $setup.state.data.newInterventionMethod === '수사지원' ||
                                                        $setup.state.data.newInterventionMethod === '소송지원'
                                                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                    _cache[327] || (_cache[327] = _createElementVNode("div", { class: "area_col_head" }, null, -1)),
                                    _createElementVNode("div", _hoisted_126, [
                                      _createElementVNode("div", _hoisted_127, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw1",
                                            checked: $setup.state.data.newInterventionMethodLaw1 === '기소',
                                            onClick: _cache[56] || (_cache[56] = ($event: any) => ($setup.state.data.newInterventionMethodLaw1 = '기소')),
                                            disabled: 
                                                                        $setup.state.data.newInterventionMethod === '소송지원' &&
                                                                        $setup.state.data.newInterventionMethodLaw0 !== '형사'
                                                                    
                                          }, null, 8, _hoisted_128),
                                          _cache[321] || (_cache[321] = _createElementVNode("em", null, null, -1)),
                                          _cache[322] || (_cache[322] = _createElementVNode("span", null, "기소", -1))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_129, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw1",
                                            checked: $setup.state.data.newInterventionMethodLaw1 === '피소',
                                            onClick: _cache[57] || (_cache[57] = ($event: any) => ($setup.state.data.newInterventionMethodLaw1 = '피소'))
                                          }, null, 8, _hoisted_130),
                                          _cache[323] || (_cache[323] = _createElementVNode("em", null, null, -1)),
                                          _cache[324] || (_cache[324] = _createElementVNode("span", null, "피소", -1))
                                        ])
                                      ]),
                                      ($setup.state.data.newInterventionMethod === '소송지원')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                            _createElementVNode("label", null, [
                                              _createElementVNode("input", {
                                                type: "radio",
                                                name: "newInterventionMethodLaw1",
                                                checked: $setup.state.data.newInterventionMethodLaw1 === '제소',
                                                onClick: _cache[58] || (_cache[58] = ($event: any) => ($setup.state.data.newInterventionMethodLaw1 = '제소')),
                                                disabled: 
                                                                        $setup.state.data.newInterventionMethod === '소송지원' &&
                                                                        $setup.state.data.newInterventionMethodLaw0 === '형사'
                                                                    
                                              }, null, 8, _hoisted_132),
                                              _cache[325] || (_cache[325] = _createElementVNode("em", null, null, -1)),
                                              _cache[326] || (_cache[326] = _createElementVNode("span", null, "제소", -1))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                                                        $setup.state.data.newInterventionMethod === '수사지원' ||
                                                        $setup.state.data.newInterventionMethod === '소송지원'
                                                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                    _cache[370] || (_cache[370] = _createElementVNode("div", { class: "area_col_head" }, null, -1)),
                                    _createElementVNode("div", _hoisted_134, [
                                      _createElementVNode("div", _hoisted_135, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw2",
                                            checked: $setup.state.data.newInterventionMethodLaw2 === '선임',
                                            onClick: _cache[59] || (_cache[59] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '선임'))
                                          }, null, 8, _hoisted_136),
                                          _cache[328] || (_cache[328] = _createElementVNode("em", null, null, -1)),
                                          _cache[329] || (_cache[329] = _createElementVNode("span", null, "선임", -1))
                                        ])
                                      ]),
                                      ($setup.state.data.newInterventionMethodLaw2 === '선임')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              placeholder: "기관명",
                                              "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (($setup.state.data.newInterventionMethodLaw2Cop) = $event))
                                            }, null, 512), [
                                              [_vModelText, $setup.state.data.newInterventionMethodLaw2Cop]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.state.data.newInterventionMethodLaw2 === '선임')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              placeholder: "변호인",
                                              "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (($setup.state.data.newInterventionMethodLaw2Name) = $event))
                                            }, null, 512), [
                                              [_vModelText, $setup.state.data.newInterventionMethodLaw2Name]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_139, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw2",
                                            checked: $setup.state.data.newInterventionMethodLaw2 === '재판동행',
                                            onClick: _cache[62] || (_cache[62] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '재판동행'))
                                          }, null, 8, _hoisted_140),
                                          _cache[330] || (_cache[330] = _createElementVNode("em", null, null, -1)),
                                          _cache[331] || (_cache[331] = _createElementVNode("span", null, "재판동행", -1))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_141, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw2",
                                            checked: $setup.state.data.newInterventionMethodLaw2 === '서면',
                                            onClick: _cache[63] || (_cache[63] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '서면'))
                                          }, null, 8, _hoisted_142),
                                          _cache[332] || (_cache[332] = _createElementVNode("em", null, null, -1)),
                                          _cache[333] || (_cache[333] = _createElementVNode("span", null, "서면", -1))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_143, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw2",
                                            checked: $setup.state.data.newInterventionMethodLaw2 === '상담',
                                            onClick: _cache[64] || (_cache[64] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '상담'))
                                          }, null, 8, _hoisted_144),
                                          _cache[334] || (_cache[334] = _createElementVNode("em", null, null, -1)),
                                          _cache[335] || (_cache[335] = _createElementVNode("span", null, "상담", -1))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_145, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodLaw2",
                                            checked: $setup.state.data.newInterventionMethodLaw2 === '증거수집',
                                            onClick: _cache[65] || (_cache[65] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '증거수집'))
                                          }, null, 8, _hoisted_146),
                                          _cache[336] || (_cache[336] = _createElementVNode("em", null, null, -1)),
                                          _cache[337] || (_cache[337] = _createElementVNode("span", null, "증거수집", -1))
                                        ])
                                      ]),
                                      ($setup.state.data.newInterventionMethodLaw0 === '민사')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createElementVNode("div", _hoisted_147, [
                                              _createElementVNode("label", null, [
                                                _createElementVNode("input", {
                                                  type: "radio",
                                                  name: "newInterventionMethodLaw2",
                                                  checked: $setup.state.data.newInterventionMethodLaw2 === '손해배상',
                                                  onClick: _cache[66] || (_cache[66] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '손해배상'))
                                                }, null, 8, _hoisted_148),
                                                _cache[338] || (_cache[338] = _createElementVNode("em", null, null, -1)),
                                                _cache[339] || (_cache[339] = _createElementVNode("span", null, "손해배상", -1))
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_149, [
                                              _createElementVNode("label", null, [
                                                _createElementVNode("input", {
                                                  type: "radio",
                                                  name: "newInterventionMethodLaw2",
                                                  checked: $setup.state.data.newInterventionMethodLaw2 === '채무부존재',
                                                  onClick: _cache[67] || (_cache[67] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '채무부존재'))
                                                }, null, 8, _hoisted_150),
                                                _cache[340] || (_cache[340] = _createElementVNode("em", null, null, -1)),
                                                _cache[341] || (_cache[341] = _createElementVNode("span", null, "채무부존재", -1))
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_151, [
                                              _createElementVNode("label", null, [
                                                _createElementVNode("input", {
                                                  type: "radio",
                                                  name: "newInterventionMethodLaw2",
                                                  checked: $setup.state.data.newInterventionMethodLaw2 === '청구이의',
                                                  onClick: _cache[68] || (_cache[68] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '청구이의'))
                                                }, null, 8, _hoisted_152),
                                                _cache[342] || (_cache[342] = _createElementVNode("em", null, null, -1)),
                                                _cache[343] || (_cache[343] = _createElementVNode("span", null, "청구이의", -1))
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_153, [
                                              _createElementVNode("label", null, [
                                                _createElementVNode("input", {
                                                  type: "radio",
                                                  name: "newInterventionMethodLaw2",
                                                  checked: $setup.state.data.newInterventionMethodLaw2 === '개인파산면책',
                                                  onClick: _cache[69] || (_cache[69] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '개인파산면책'))
                                                }, null, 8, _hoisted_154),
                                                _cache[344] || (_cache[344] = _createElementVNode("em", null, null, -1)),
                                                _cache[345] || (_cache[345] = _createElementVNode("span", null, "개인파산면책", -1))
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_155, [
                                              _createElementVNode("label", null, [
                                                _createElementVNode("input", {
                                                  type: "radio",
                                                  name: "newInterventionMethodLaw2",
                                                  checked: $setup.state.data.newInterventionMethodLaw2 === '부당이익',
                                                  onClick: _cache[70] || (_cache[70] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '부당이익'))
                                                }, null, 8, _hoisted_156),
                                                _cache[346] || (_cache[346] = _createElementVNode("em", null, null, -1)),
                                                _cache[347] || (_cache[347] = _createElementVNode("span", null, "부당이익", -1))
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_157, [
                                              _createElementVNode("label", null, [
                                                _createElementVNode("input", {
                                                  type: "radio",
                                                  name: "newInterventionMethodLaw2",
                                                  checked: $setup.state.data.newInterventionMethodLaw2 === '대여금',
                                                  onClick: _cache[71] || (_cache[71] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '대여금'))
                                                }, null, 8, _hoisted_158),
                                                _cache[348] || (_cache[348] = _createElementVNode("em", null, null, -1)),
                                                _cache[349] || (_cache[349] = _createElementVNode("span", null, "대여금", -1))
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_159, [
                                              _createElementVNode("label", null, [
                                                _createElementVNode("input", {
                                                  type: "radio",
                                                  name: "newInterventionMethodLaw2",
                                                  checked: $setup.state.data.newInterventionMethodLaw2 === '기타',
                                                  onClick: _cache[72] || (_cache[72] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '기타'))
                                                }, null, 8, _hoisted_160),
                                                _cache[350] || (_cache[350] = _createElementVNode("em", null, null, -1)),
                                                _cache[351] || (_cache[351] = _createElementVNode("span", null, "기타", -1))
                                              ])
                                            ])
                                          ], 64))
                                        : ($setup.state.data.newInterventionMethodLaw0 === '형사')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                              _createElementVNode("div", _hoisted_161, [
                                                _createElementVNode("label", null, [
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    name: "newInterventionMethodLaw2",
                                                    checked: $setup.state.data.newInterventionMethodLaw2 === '성매매',
                                                    onClick: _cache[73] || (_cache[73] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '성매매'))
                                                  }, null, 8, _hoisted_162),
                                                  _cache[352] || (_cache[352] = _createElementVNode("em", null, null, -1)),
                                                  _cache[353] || (_cache[353] = _createElementVNode("span", null, "성매매", -1))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_163, [
                                                _createElementVNode("label", null, [
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    name: "newInterventionMethodLaw2",
                                                    checked: $setup.state.data.newInterventionMethodLaw2 === '사기',
                                                    onClick: _cache[74] || (_cache[74] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '사기'))
                                                  }, null, 8, _hoisted_164),
                                                  _cache[354] || (_cache[354] = _createElementVNode("em", null, null, -1)),
                                                  _cache[355] || (_cache[355] = _createElementVNode("span", null, "사기", -1))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_165, [
                                                _createElementVNode("label", null, [
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    name: "newInterventionMethodLaw2",
                                                    checked: $setup.state.data.newInterventionMethodLaw2 === '성폭행/상해',
                                                    onClick: _cache[75] || (_cache[75] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '성폭행/상해'))
                                                  }, null, 8, _hoisted_166),
                                                  _cache[356] || (_cache[356] = _createElementVNode("em", null, null, -1)),
                                                  _cache[357] || (_cache[357] = _createElementVNode("span", null, "성폭행/상해", -1))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_167, [
                                                _createElementVNode("label", null, [
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    name: "newInterventionMethodLaw2",
                                                    checked: $setup.state.data.newInterventionMethodLaw2 === '주거침입',
                                                    onClick: _cache[76] || (_cache[76] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '주거침입'))
                                                  }, null, 8, _hoisted_168),
                                                  _cache[358] || (_cache[358] = _createElementVNode("em", null, null, -1)),
                                                  _cache[359] || (_cache[359] = _createElementVNode("span", null, "주거침입", -1))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_169, [
                                                _createElementVNode("label", null, [
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    name: "newInterventionMethodLaw2",
                                                    checked: $setup.state.data.newInterventionMethodLaw2 === '명예훼손',
                                                    onClick: _cache[77] || (_cache[77] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '명예훼손'))
                                                  }, null, 8, _hoisted_170),
                                                  _cache[360] || (_cache[360] = _createElementVNode("em", null, null, -1)),
                                                  _cache[361] || (_cache[361] = _createElementVNode("span", null, "명예훼손", -1))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_171, [
                                                _createElementVNode("label", null, [
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    name: "newInterventionMethodLaw2",
                                                    checked: $setup.state.data.newInterventionMethodLaw2 === '협박',
                                                    onClick: _cache[78] || (_cache[78] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '협박'))
                                                  }, null, 8, _hoisted_172),
                                                  _cache[362] || (_cache[362] = _createElementVNode("em", null, null, -1)),
                                                  _cache[363] || (_cache[363] = _createElementVNode("span", null, "협박", -1))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_173, [
                                                _createElementVNode("label", null, [
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    name: "newInterventionMethodLaw2",
                                                    checked: $setup.state.data.newInterventionMethodLaw2 === '아청법',
                                                    onClick: _cache[79] || (_cache[79] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '아청법'))
                                                  }, null, 8, _hoisted_174),
                                                  _cache[364] || (_cache[364] = _createElementVNode("em", null, null, -1)),
                                                  _cache[365] || (_cache[365] = _createElementVNode("span", null, "아청법", -1))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_175, [
                                                _createElementVNode("label", null, [
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    name: "newInterventionMethodLaw2",
                                                    checked: $setup.state.data.newInterventionMethodLaw2 === '디지털성범죄',
                                                    onClick: _cache[80] || (_cache[80] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '디지털성범죄'))
                                                  }, null, 8, _hoisted_176),
                                                  _cache[366] || (_cache[366] = _createElementVNode("em", null, null, -1)),
                                                  _cache[367] || (_cache[367] = _createElementVNode("span", null, "디지털성범죄", -1))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_177, [
                                                _createElementVNode("label", null, [
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    name: "newInterventionMethodLaw2",
                                                    checked: $setup.state.data.newInterventionMethodLaw2 === '기타',
                                                    onClick: _cache[81] || (_cache[81] = ($event: any) => ($setup.state.data.newInterventionMethodLaw2 = '기타'))
                                                  }, null, 8, _hoisted_178),
                                                  _cache[368] || (_cache[368] = _createElementVNode("em", null, null, -1)),
                                                  _cache[369] || (_cache[369] = _createElementVNode("span", null, "기타", -1))
                                                ])
                                              ]),
                                              ($setup.state.data.newInterventionMethodLaw2 === '기타')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => (($setup.state.data.newInterventionMethodLaw2Txt) = $event))
                                                    }, null, 512), [
                                                      [_vModelText, $setup.state.data.newInterventionMethodLaw2Txt]
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.state.data.result === '의료지원')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                          _cache[407] || (_cache[407] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "의료지원")
                          ], -1)),
                          _createElementVNode("div", _hoisted_181, [
                            _createElementVNode("div", _hoisted_182, [
                              _createElementVNode("div", _hoisted_183, [
                                _createElementVNode("div", _hoisted_184, [
                                  _cache[392] || (_cache[392] = _createElementVNode("label", null, "[양방]", -1)),
                                  _createElementVNode("div", _hoisted_185, [
                                    _createElementVNode("div", _hoisted_186, [
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '정신과',
                                          onClick: _cache[83] || (_cache[83] = ($event: any) => ($setup.state.data.newInterventionMethod = '정신과'))
                                        }, null, 8, _hoisted_187),
                                        _cache[372] || (_cache[372] = _createElementVNode("em", null, null, -1)),
                                        _cache[373] || (_cache[373] = _createElementVNode("span", null, "정신건강의학", -1))
                                      ]),
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '산부인과',
                                          onClick: _cache[84] || (_cache[84] = ($event: any) => ($setup.state.data.newInterventionMethod = '산부인과'))
                                        }, null, 8, _hoisted_188),
                                        _cache[374] || (_cache[374] = _createElementVNode("em", null, null, -1)),
                                        _cache[375] || (_cache[375] = _createElementVNode("span", null, "산부인과", -1))
                                      ]),
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '내과',
                                          onClick: _cache[85] || (_cache[85] = ($event: any) => ($setup.state.data.newInterventionMethod = '내과'))
                                        }, null, 8, _hoisted_189),
                                        _cache[376] || (_cache[376] = _createElementVNode("em", null, null, -1)),
                                        _cache[377] || (_cache[377] = _createElementVNode("span", null, "내과", -1))
                                      ]),
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '치과',
                                          onClick: _cache[86] || (_cache[86] = ($event: any) => ($setup.state.data.newInterventionMethod = '치과'))
                                        }, null, 8, _hoisted_190),
                                        _cache[378] || (_cache[378] = _createElementVNode("em", null, null, -1)),
                                        _cache[379] || (_cache[379] = _createElementVNode("span", null, "치과", -1))
                                      ]),
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '외과',
                                          onClick: _cache[87] || (_cache[87] = ($event: any) => ($setup.state.data.newInterventionMethod = '외과'))
                                        }, null, 8, _hoisted_191),
                                        _cache[380] || (_cache[380] = _createElementVNode("em", null, null, -1)),
                                        _cache[381] || (_cache[381] = _createElementVNode("span", null, "외과", -1))
                                      ]),
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '피부과',
                                          onClick: _cache[88] || (_cache[88] = ($event: any) => ($setup.state.data.newInterventionMethod = '피부과'))
                                        }, null, 8, _hoisted_192),
                                        _cache[382] || (_cache[382] = _createElementVNode("em", null, null, -1)),
                                        _cache[383] || (_cache[383] = _createElementVNode("span", null, "피부과", -1))
                                      ]),
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: 
                                                                            $setup.state.data.newInterventionMethod.includes('안과') ||
                                                                            $setup.state.data.newInterventionMethod.includes('이비인후과')
                                                                        ,
                                          onClick: _cache[89] || (_cache[89] = ($event: any) => ($setup.state.data.newInterventionMethod = '안과/이비인후과'))
                                        }, null, 8, _hoisted_193),
                                        _cache[384] || (_cache[384] = _createElementVNode("em", null, null, -1)),
                                        _cache[385] || (_cache[385] = _createElementVNode("span", null, "안과/이비인후과", -1))
                                      ]),
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '비뇨기과',
                                          onClick: _cache[90] || (_cache[90] = ($event: any) => ($setup.state.data.newInterventionMethod = '비뇨기과'))
                                        }, null, 8, _hoisted_194),
                                        _cache[386] || (_cache[386] = _createElementVNode("em", null, null, -1)),
                                        _cache[387] || (_cache[387] = _createElementVNode("span", null, "비교기과", -1))
                                      ]),
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '종합건강검진',
                                          onClick: _cache[91] || (_cache[91] = ($event: any) => ($setup.state.data.newInterventionMethod = '종합건강검진'))
                                        }, null, 8, _hoisted_195),
                                        _cache[388] || (_cache[388] = _createElementVNode("em", null, null, -1)),
                                        _cache[389] || (_cache[389] = _createElementVNode("span", null, "건강검진", -1))
                                      ]),
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '개입방법/의료지원/기타',
                                          onClick: _cache[92] || (_cache[92] = ($event: any) => ($setup.state.data.newInterventionMethod = '개입방법/의료지원/기타'))
                                        }, null, 8, _hoisted_196),
                                        _cache[390] || (_cache[390] = _createElementVNode("em", null, null, -1)),
                                        _cache[391] || (_cache[391] = _createElementVNode("span", null, "기타", -1)),
                                        ($setup.state.data.newInterventionMethod === '개입방법/의료지원/기타')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => (($setup.state.data.newInterventionMethodTxt1) = $event))
                                              }, null, 512), [
                                                [_vModelText, $setup.state.data.newInterventionMethodTxt1]
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    (
                                                                    $setup.state.data.newInterventionMethod !== '한방' &&
                                                                    $setup.state.data.newInterventionMethod !== '건강상담'
                                                                )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_199, [
                                              _createElementVNode("div", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "text",
                                                  placeholder: "병원명",
                                                  "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => (($setup.state.data.newInterventionMethodMedicalCop) = $event))
                                                }, null, 512), [
                                                  [_vModelText, $setup.state.data.newInterventionMethodMedicalCop]
                                                ])
                                              ]),
                                              _createElementVNode("div", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "text",
                                                  placeholder: "주치의",
                                                  "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => (($setup.state.data.newInterventionMethodMedicalName) = $event))
                                                }, null, 512), [
                                                  [_vModelText, $setup.state.data.newInterventionMethodMedicalName]
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                ($setup.state.data.newInterventionMethod === '개입방법/의료지원/기타')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                                      _createElementVNode("div", _hoisted_201, [
                                        _createElementVNode("div", _hoisted_202, [
                                          _createElementVNode("label", null, [
                                            _createElementVNode("input", {
                                              type: "radio",
                                              name: "newInterventionMethodTxt1",
                                              checked: $setup.state.data.newInterventionMethodTxt1 === '재활의학과',
                                              onClick: _cache[96] || (_cache[96] = ($event: any) => ($setup.state.data.newInterventionMethodTxt1 = '재활의학과'))
                                            }, null, 8, _hoisted_203),
                                            _cache[393] || (_cache[393] = _createElementVNode("em", null, null, -1)),
                                            _cache[394] || (_cache[394] = _createElementVNode("span", null, "재활의학과", -1))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_204, [
                                          _createElementVNode("label", null, [
                                            _createElementVNode("input", {
                                              type: "radio",
                                              name: "newInterventionMethodTxt1",
                                              checked: $setup.state.data.newInterventionMethodTxt1 === '영상의학과',
                                              onClick: _cache[97] || (_cache[97] = ($event: any) => ($setup.state.data.newInterventionMethodTxt1 = '영상의학과'))
                                            }, null, 8, _hoisted_205),
                                            _cache[395] || (_cache[395] = _createElementVNode("em", null, null, -1)),
                                            _cache[396] || (_cache[396] = _createElementVNode("span", null, "영상의학과", -1))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_206, [
                                          _createElementVNode("label", null, [
                                            _createElementVNode("input", {
                                              type: "radio",
                                              name: "newInterventionMethodTxt1",
                                              checked: $setup.state.data.newInterventionMethodTxt1 === '마취통증의학과',
                                              onClick: _cache[98] || (_cache[98] = ($event: any) => ($setup.state.data.newInterventionMethodTxt1 = '마취통증의학과'))
                                            }, null, 8, _hoisted_207),
                                            _cache[397] || (_cache[397] = _createElementVNode("em", null, null, -1)),
                                            _cache[398] || (_cache[398] = _createElementVNode("span", null, "마취통증의학과", -1))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_208, [
                                          _createElementVNode("label", null, [
                                            _createElementVNode("input", {
                                              type: "radio",
                                              name: "newInterventionMethodTxt1",
                                              checked: $setup.state.data.newInterventionMethodTxt1 === '수면의학과',
                                              onClick: _cache[99] || (_cache[99] = ($event: any) => ($setup.state.data.newInterventionMethodTxt1 = '수면의학과'))
                                            }, null, 8, _hoisted_209),
                                            _cache[399] || (_cache[399] = _createElementVNode("em", null, null, -1)),
                                            _cache[400] || (_cache[400] = _createElementVNode("span", null, "수면의학과", -1))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_210, [
                                  _cache[403] || (_cache[403] = _createElementVNode("label", null, "[한방]", -1)),
                                  _createElementVNode("div", _hoisted_211, [
                                    _createElementVNode("div", _hoisted_212, [
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '한방',
                                          onClick: _cache[100] || (_cache[100] = ($event: any) => ($setup.state.data.newInterventionMethod = '한방'))
                                        }, null, 8, _hoisted_213),
                                        _cache[401] || (_cache[401] = _createElementVNode("em", null, null, -1)),
                                        _cache[402] || (_cache[402] = _createElementVNode("span", null, "한방", -1))
                                      ])
                                    ]),
                                    ($setup.state.data.newInterventionMethod === '한방')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            placeholder: "병원명",
                                            "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => (($setup.state.data.newInterventionMethodMedicalCop) = $event))
                                          }, null, 512), [
                                            [_vModelText, $setup.state.data.newInterventionMethodMedicalCop]
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    ($setup.state.data.newInterventionMethod === '한방')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            placeholder: "주치의",
                                            "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => (($setup.state.data.newInterventionMethodMedicalName) = $event))
                                          }, null, 512), [
                                            [_vModelText, $setup.state.data.newInterventionMethodMedicalName]
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_216, [
                                  _cache[406] || (_cache[406] = _createElementVNode("label", null, "[건강상담]", -1)),
                                  _createElementVNode("div", _hoisted_217, [
                                    _createElementVNode("div", _hoisted_218, [
                                      _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: "newInterventionMethod",
                                          checked: $setup.state.data.newInterventionMethod === '건강상담',
                                          onClick: _cache[103] || (_cache[103] = ($event: any) => ($setup.state.data.newInterventionMethod = '건강상담'))
                                        }, null, 8, _hoisted_219),
                                        _cache[404] || (_cache[404] = _createElementVNode("em", null, null, -1)),
                                        _cache[405] || (_cache[405] = _createElementVNode("span", null, "건강상담", -1))
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.state.data.result === '정서적지원')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                          _cache[436] || (_cache[436] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "서비스/ 자원제공")
                          ], -1)),
                          _createElementVNode("div", _hoisted_221, [
                            _createElementVNode("div", _hoisted_222, [
                              _createElementVNode("div", _hoisted_223, [
                                _cache[420] || (_cache[420] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[정서지원]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_224, [
                                  _createElementVNode("div", _hoisted_225, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '일상생활상담',
                                        onClick: _cache[104] || (_cache[104] = ($event: any) => ($setup.state.data.newInterventionMethod = '일상생활상담'))
                                      }, null, 8, _hoisted_226),
                                      _cache[408] || (_cache[408] = _createElementVNode("em", null, null, -1)),
                                      _cache[409] || (_cache[409] = _createElementVNode("span", null, "일상생활상담", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '가족문제상담',
                                        onClick: _cache[105] || (_cache[105] = ($event: any) => ($setup.state.data.newInterventionMethod = '가족문제상담'))
                                      }, null, 8, _hoisted_227),
                                      _cache[410] || (_cache[410] = _createElementVNode("em", null, null, -1)),
                                      _cache[411] || (_cache[411] = _createElementVNode("span", null, "가족문제상담", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '경제문제상담',
                                        onClick: _cache[106] || (_cache[106] = ($event: any) => ($setup.state.data.newInterventionMethod = '경제문제상담'))
                                      }, null, 8, _hoisted_228),
                                      _cache[412] || (_cache[412] = _createElementVNode("em", null, null, -1)),
                                      _cache[413] || (_cache[413] = _createElementVNode("span", null, "경제문제상담", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '정보제공',
                                        onClick: _cache[107] || (_cache[107] = ($event: any) => ($setup.state.data.newInterventionMethod = '정보제공'))
                                      }, null, 8, _hoisted_229),
                                      _cache[414] || (_cache[414] = _createElementVNode("em", null, null, -1)),
                                      _cache[415] || (_cache[415] = _createElementVNode("span", null, "정보제공", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '타기관 상담의뢰',
                                        onClick: _cache[108] || (_cache[108] = ($event: any) => ($setup.state.data.newInterventionMethod = '타기관 상담의뢰'))
                                      }, null, 8, _hoisted_230),
                                      _cache[416] || (_cache[416] = _createElementVNode("em", null, null, -1)),
                                      _cache[417] || (_cache[417] = _createElementVNode("span", null, "타기관 상담의뢰", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '사부작공방 관련',
                                        onClick: _cache[109] || (_cache[109] = ($event: any) => ($setup.state.data.newInterventionMethod = '사부작공방 관련'))
                                      }, null, 8, _hoisted_231),
                                      _cache[418] || (_cache[418] = _createElementVNode("em", null, null, -1)),
                                      _cache[419] || (_cache[419] = _createElementVNode("span", null, "사부작공방관련", -1))
                                    ])
                                  ])
                                ])
                              ]),
                              (
                                                        $setup.state.data.newInterventionMethod === '정보제공' ||
                                                        $setup.state.data.newInterventionMethod === '타기관 상담의뢰'
                                                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                    _cache[435] || (_cache[435] = _createElementVNode("div", { class: "area_col_head" }, "[의뢰기관]", -1)),
                                    _createElementVNode("div", _hoisted_233, [
                                      _createElementVNode("div", _hoisted_234, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodEmotionOtherInstitutions",
                                            checked: 
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions === '경찰·검찰·법원'
                                                                    ,
                                            onClick: _cache[110] || (_cache[110] = ($event: any) => (
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions = '경찰·검찰·법원'
                                                                    ))
                                          }, null, 8, _hoisted_235),
                                          _cache[421] || (_cache[421] = _createElementVNode("em", null, null, -1)),
                                          _cache[422] || (_cache[422] = _createElementVNode("span", null, "경찰·검찰·법원", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodEmotionOtherInstitutions",
                                            checked: 
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions === '성매매방지기관'
                                                                    ,
                                            onClick: _cache[111] || (_cache[111] = ($event: any) => (
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions = '성매매방지기관'
                                                                    ))
                                          }, null, 8, _hoisted_236),
                                          _cache[423] || (_cache[423] = _createElementVNode("em", null, null, -1)),
                                          _cache[424] || (_cache[424] = _createElementVNode("span", null, "성매매방지기관", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodEmotionOtherInstitutions",
                                            checked: 
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions === '전문상담기관'
                                                                    ,
                                            onClick: _cache[112] || (_cache[112] = ($event: any) => ($setup.state.data.newInterventionMethodEmotionOtherInstitutions = '전문상담기관'))
                                          }, null, 8, _hoisted_237),
                                          _cache[425] || (_cache[425] = _createElementVNode("em", null, null, -1)),
                                          _cache[426] || (_cache[426] = _createElementVNode("span", null, "전문상담기관", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodEmotionOtherInstitutions",
                                            checked: 
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions ===
                                                                        '직업훈련·알선기관'
                                                                    ,
                                            onClick: _cache[113] || (_cache[113] = ($event: any) => (
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions = '직업훈련·알선기관'
                                                                    ))
                                          }, null, 8, _hoisted_238),
                                          _cache[427] || (_cache[427] = _createElementVNode("em", null, null, -1)),
                                          _cache[428] || (_cache[428] = _createElementVNode("span", null, "직업훈련·알선기관", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodEmotionOtherInstitutions",
                                            checked: 
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions === '1366·1388 등'
                                                                    ,
                                            onClick: _cache[114] || (_cache[114] = ($event: any) => ($setup.state.data.newInterventionMethodEmotionOtherInstitutions = '1366·1388 등'))
                                          }, null, 8, _hoisted_239),
                                          _cache[429] || (_cache[429] = _createElementVNode("em", null, null, -1)),
                                          _cache[430] || (_cache[430] = _createElementVNode("span", null, "1366·1388 등", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodEmotionOtherInstitutions",
                                            checked: 
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions ===
                                                                        '학교·대안교육기관'
                                                                    ,
                                            onClick: _cache[115] || (_cache[115] = ($event: any) => (
                                                                        $setup.state.data.newInterventionMethodEmotionOtherInstitutions = '학교·대안교육기관'
                                                                    ))
                                          }, null, 8, _hoisted_240),
                                          _cache[431] || (_cache[431] = _createElementVNode("em", null, null, -1)),
                                          _cache[432] || (_cache[432] = _createElementVNode("span", null, "학교·대안교육기관", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodEmotionOtherInstitutions",
                                            checked: $setup.state.data.newInterventionMethodEmotionOtherInstitutions === '기타',
                                            onClick: _cache[116] || (_cache[116] = ($event: any) => ($setup.state.data.newInterventionMethodEmotionOtherInstitutions = '기타'))
                                          }, null, 8, _hoisted_241),
                                          _cache[433] || (_cache[433] = _createElementVNode("em", null, null, -1)),
                                          _cache[434] || (_cache[434] = _createElementVNode("span", null, "기타", -1))
                                        ])
                                      ]),
                                      (
                                                                ($setup.state.data.newInterventionMethod === '정보제공' ||
                                                                    $setup.state.data.newInterventionMethod === '타기관 상담의뢰') &&
                                                                $setup.state.data.newInterventionMethodEmotionOtherInstitutions !== ''
                                                            )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_242, [
                                            _withDirectives(_createElementVNode("input", {
                                              tyep: "text",
                                              "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => (($setup.state.data.newInterventionMethodEmotionOtherInstitutionsDesc) = $event))
                                            }, null, 512), [
                                              [_vModelText, $setup.state.data.newInterventionMethodEmotionOtherInstitutionsDesc]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.state.data.result === '자활지원')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                          _cache[448] || (_cache[448] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "서비스/ 자원제공")
                          ], -1)),
                          _createElementVNode("div", _hoisted_244, [
                            _createElementVNode("div", _hoisted_245, [
                              _createElementVNode("div", _hoisted_246, [
                                _cache[447] || (_cache[447] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[자활지원]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_247, [
                                  _createElementVNode("div", _hoisted_248, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '자활상담/정보제공/지원',
                                        onClick: _cache[118] || (_cache[118] = ($event: any) => ($setup.state.data.newInterventionMethod = '자활상담/정보제공/지원'))
                                      }, null, 8, _hoisted_249),
                                      _cache[437] || (_cache[437] = _createElementVNode("em", null, null, -1)),
                                      _cache[438] || (_cache[438] = _createElementVNode("span", null, "자활상담/정보제공/지원", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '주거상담/정보제공/지원',
                                        onClick: _cache[119] || (_cache[119] = ($event: any) => ($setup.state.data.newInterventionMethod = '주거상담/정보제공/지원'))
                                      }, null, 8, _hoisted_250),
                                      _cache[439] || (_cache[439] = _createElementVNode("em", null, null, -1)),
                                      _cache[440] || (_cache[440] = _createElementVNode("span", null, "주거상담/정보제공/지원", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '자활관련기초검사',
                                        onClick: _cache[120] || (_cache[120] = ($event: any) => ($setup.state.data.newInterventionMethod = '자활관련기초검사'))
                                      }, null, 8, _hoisted_251),
                                      _cache[441] || (_cache[441] = _createElementVNode("em", null, null, -1)),
                                      _cache[442] || (_cache[442] = _createElementVNode("span", null, "자활관련기초검사", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '직업훈련수당',
                                        onClick: _cache[121] || (_cache[121] = ($event: any) => ($setup.state.data.newInterventionMethod = '직업훈련수당'))
                                      }, null, 8, _hoisted_252),
                                      _cache[443] || (_cache[443] = _createElementVNode("em", null, null, -1)),
                                      _cache[444] || (_cache[444] = _createElementVNode("span", null, "직업훈련수당", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: 
                                                                        $setup.state.data.newInterventionMethod === '개입방법/서비스자원제공/자활지원/기타'
                                                                    ,
                                        onClick: _cache[122] || (_cache[122] = ($event: any) => (
                                                                        $setup.state.data.newInterventionMethod = '개입방법/서비스자원제공/자활지원/기타'
                                                                    ))
                                      }, null, 8, _hoisted_253),
                                      _cache[445] || (_cache[445] = _createElementVNode("em", null, null, -1)),
                                      _cache[446] || (_cache[446] = _createElementVNode("span", null, "기타", -1))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.state.data.result === '집단프로그램')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                          _cache[469] || (_cache[469] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "서비스/ 자원제공")
                          ], -1)),
                          _createElementVNode("div", _hoisted_255, [
                            _createElementVNode("div", _hoisted_256, [
                              _createElementVNode("div", _hoisted_257, [
                                _cache[461] || (_cache[461] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[집단프로그램]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_258, [
                                  _createElementVNode("div", _hoisted_259, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '심리정서프로그램',
                                        onClick: _cache[123] || (_cache[123] = ($event: any) => ($setup.state.data.newInterventionMethod = '심리정서프로그램'))
                                      }, null, 8, _hoisted_260),
                                      _cache[449] || (_cache[449] = _createElementVNode("em", null, null, -1)),
                                      _cache[450] || (_cache[450] = _createElementVNode("span", null, "심리정서프로그램", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '사각지대 프로그램',
                                        onClick: _cache[124] || (_cache[124] = ($event: any) => ($setup.state.data.newInterventionMethod = '사각지대 프로그램'))
                                      }, null, 8, _hoisted_261),
                                      _cache[451] || (_cache[451] = _createElementVNode("em", null, null, -1)),
                                      _cache[452] || (_cache[452] = _createElementVNode("span", null, "사각지대프로그램", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '사회적응프로그램',
                                        onClick: _cache[125] || (_cache[125] = ($event: any) => ($setup.state.data.newInterventionMethod = '사회적응프로그램'))
                                      }, null, 8, _hoisted_262),
                                      _cache[453] || (_cache[453] = _createElementVNode("em", null, null, -1)),
                                      _cache[454] || (_cache[454] = _createElementVNode("span", null, "사회적응프로그램", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '문화/체험활동',
                                        onClick: _cache[126] || (_cache[126] = ($event: any) => ($setup.state.data.newInterventionMethod = '문화/체험활동'))
                                      }, null, 8, _hoisted_263),
                                      _cache[455] || (_cache[455] = _createElementVNode("em", null, null, -1)),
                                      _cache[456] || (_cache[456] = _createElementVNode("span", null, "문화/체험활동", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '건강관리/체력강화',
                                        onClick: _cache[127] || (_cache[127] = ($event: any) => ($setup.state.data.newInterventionMethod = '건강관리/체력강화'))
                                      }, null, 8, _hoisted_264),
                                      _cache[457] || (_cache[457] = _createElementVNode("em", null, null, -1)),
                                      _cache[458] || (_cache[458] = _createElementVNode("span", null, "건강관리/체력강화", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: 
                                                                        $setup.state.data.newInterventionMethod ===
                                                                        '개입방법/서비스자원제공/집단프로그램/기타'
                                                                    ,
                                        onClick: _cache[128] || (_cache[128] = ($event: any) => (
                                                                        $setup.state.data.newInterventionMethod = '개입방법/서비스자원제공/집단프로그램/기타'
                                                                    ))
                                      }, null, 8, _hoisted_265),
                                      _cache[459] || (_cache[459] = _createElementVNode("em", null, null, -1)),
                                      _cache[460] || (_cache[460] = _createElementVNode("span", null, "기타", -1))
                                    ])
                                  ]),
                                  ($setup.state.data.newInterventionMethod === '개입방법/서비스자원제공/집단프로그램/기타')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          placeholder: "",
                                          "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event: any) => (($setup.state.data.newInterventionMethodTxt2) = $event))
                                        }, null, 512), [
                                          [_vModelText, $setup.state.data.newInterventionMethodTxt2]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              ($setup.state.data.newInterventionMethod === '사각지대 프로그램')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_267, [
                                    _cache[468] || (_cache[468] = _createElementVNode("div", { class: "area_col_head" }, [
                                      _createElementVNode("label", null, "[사각지대프로그램]")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_268, [
                                      _createElementVNode("div", _hoisted_269, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodGroupProgram",
                                            checked: $setup.state.data.newInterventionMethodGroupProgram === '사부작공방',
                                            onClick: _cache[130] || (_cache[130] = ($event: any) => ($setup.state.data.newInterventionMethodGroupProgram = '사부작공방'))
                                          }, null, 8, _hoisted_270),
                                          _cache[462] || (_cache[462] = _createElementVNode("em", null, null, -1)),
                                          _cache[463] || (_cache[463] = _createElementVNode("span", null, "사부작공방", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodGroupProgram",
                                            checked: $setup.state.data.newInterventionMethodGroupProgram === '사회적응력향상',
                                            onClick: _cache[131] || (_cache[131] = ($event: any) => ($setup.state.data.newInterventionMethodGroupProgram = '사회적응력향상'))
                                          }, null, 8, _hoisted_271),
                                          _cache[464] || (_cache[464] = _createElementVNode("em", null, null, -1)),
                                          _cache[465] || (_cache[465] = _createElementVNode("span", null, "사회적응력향상", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodGroupProgram",
                                            checked: $setup.state.data.newInterventionMethodGroupProgram === '동료활동',
                                            onClick: _cache[132] || (_cache[132] = ($event: any) => ($setup.state.data.newInterventionMethodGroupProgram = '동료활동'))
                                          }, null, 8, _hoisted_272),
                                          _cache[466] || (_cache[466] = _createElementVNode("em", null, null, -1)),
                                          _cache[467] || (_cache[467] = _createElementVNode("span", null, "동료활동", -1))
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event: any) => (($setup.state.data.newInterventionMethodGroupProgramDesc) = $event))
                                        }, null, 512), [
                                          [_vModelText, $setup.state.data.newInterventionMethodGroupProgramDesc]
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.state.data.result === '물적자원')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_273, [
                          _cache[475] || (_cache[475] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "서비스/ 자원제공")
                          ], -1)),
                          _createElementVNode("div", _hoisted_274, [
                            _createElementVNode("div", _hoisted_275, [
                              _createElementVNode("div", _hoisted_276, [
                                _cache[474] || (_cache[474] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[물적자원]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_277, [
                                  _createElementVNode("div", _hoisted_278, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: 
                                                                        $setup.state.data.newInterventionMethod === '개입방법/서비스자원제공/물적지원/물품'
                                                                    ,
                                        onClick: _cache[134] || (_cache[134] = ($event: any) => (
                                                                        $setup.state.data.newInterventionMethod = '개입방법/서비스자원제공/물적지원/물품'
                                                                    ))
                                      }, null, 8, _hoisted_279),
                                      _cache[470] || (_cache[470] = _createElementVNode("em", null, null, -1)),
                                      _cache[471] || (_cache[471] = _createElementVNode("span", null, "물품", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: 
                                                                        $setup.state.data.newInterventionMethod === '개입방법/서비스자원제공/물적지원/후원금'
                                                                    ,
                                        onClick: _cache[135] || (_cache[135] = ($event: any) => (
                                                                        $setup.state.data.newInterventionMethod = '개입방법/서비스자원제공/물적지원/후원금'
                                                                    ))
                                      }, null, 8, _hoisted_280),
                                      _cache[472] || (_cache[472] = _createElementVNode("em", null, null, -1)),
                                      _cache[473] || (_cache[473] = _createElementVNode("span", null, "후원금", -1))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.state.data.result === '물적자원')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_281, [
                          _cache[481] || (_cache[481] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "서비스/ 자원연결")
                          ], -1)),
                          _createElementVNode("div", _hoisted_282, [
                            _createElementVNode("div", _hoisted_283, [
                              _createElementVNode("div", _hoisted_284, [
                                _cache[480] || (_cache[480] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[물적자원]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_285, [
                                  _createElementVNode("div", _hoisted_286, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: 
                                                                        $setup.state.data.newInterventionMethod === '개입방법/서비스연결/물적직원/물품'
                                                                    ,
                                        onClick: _cache[136] || (_cache[136] = ($event: any) => ($setup.state.data.newInterventionMethod = '개입방법/서비스연결/물적직원/물품'))
                                      }, null, 8, _hoisted_287),
                                      _cache[476] || (_cache[476] = _createElementVNode("em", null, null, -1)),
                                      _cache[477] || (_cache[477] = _createElementVNode("span", null, "물품", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: 
                                                                        $setup.state.data.newInterventionMethod === '개입방법/서비스연결/물적직원/후원금'
                                                                    ,
                                        onClick: _cache[137] || (_cache[137] = ($event: any) => ($setup.state.data.newInterventionMethod = '개입방법/서비스연결/물적직원/후원금'))
                                      }, null, 8, _hoisted_288),
                                      _cache[478] || (_cache[478] = _createElementVNode("em", null, null, -1)),
                                      _cache[479] || (_cache[479] = _createElementVNode("span", null, "후원금", -1))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.state.data.result === '심리지원')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_289, [
                          _cache[489] || (_cache[489] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "서비스/ 자원연결")
                          ], -1)),
                          _createElementVNode("div", _hoisted_290, [
                            _createElementVNode("div", _hoisted_291, [
                              _createElementVNode("div", _hoisted_292, [
                                _cache[488] || (_cache[488] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[심리지원]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_293, [
                                  _createElementVNode("div", _hoisted_294, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '개별상담',
                                        onClick: _cache[138] || (_cache[138] = ($event: any) => ($setup.state.data.newInterventionMethod = '개별상담'))
                                      }, null, 8, _hoisted_295),
                                      _cache[482] || (_cache[482] = _createElementVNode("em", null, null, -1)),
                                      _cache[483] || (_cache[483] = _createElementVNode("span", null, "개별상담", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '집단상담',
                                        onClick: _cache[139] || (_cache[139] = ($event: any) => ($setup.state.data.newInterventionMethod = '집단상담'))
                                      }, null, 8, _hoisted_296),
                                      _cache[484] || (_cache[484] = _createElementVNode("em", null, null, -1)),
                                      _cache[485] || (_cache[485] = _createElementVNode("span", null, "집단상담", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '임상심리검사',
                                        onClick: _cache[140] || (_cache[140] = ($event: any) => ($setup.state.data.newInterventionMethod = '임상심리검사'))
                                      }, null, 8, _hoisted_297),
                                      _cache[486] || (_cache[486] = _createElementVNode("em", null, null, -1)),
                                      _cache[487] || (_cache[487] = _createElementVNode("span", null, "임상심리검사", -1))
                                    ])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      placeholder: "기관명",
                                      "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event: any) => (($setup.state.data.newInterventionMethodPsychologyCop) = $event))
                                    }, null, 512), [
                                      [_vModelText, $setup.state.data.newInterventionMethodPsychologyCop]
                                    ])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      placeholder: "상담사",
                                      "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event: any) => (($setup.state.data.newInterventionMethodPsychologyName) = $event))
                                    }, null, 512), [
                                      [_vModelText, $setup.state.data.newInterventionMethodPsychologyName]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.state.data.result === '관련기관연계')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_298, [
                          _cache[529] || (_cache[529] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "타기관의뢰")
                          ], -1)),
                          _createElementVNode("div", _hoisted_299, [
                            _createElementVNode("div", _hoisted_300, [
                              _createElementVNode("div", _hoisted_301, [
                                _cache[508] || (_cache[508] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[기관유형]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_302, [
                                  _createElementVNode("div", _hoisted_303, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '타(성매매)상담소',
                                        onClick: _cache[143] || (_cache[143] = ($event: any) => ($setup.state.data.newInterventionMethod = '타(성매매)상담소'))
                                      }, null, 8, _hoisted_304),
                                      _cache[490] || (_cache[490] = _createElementVNode("em", null, null, -1)),
                                      _cache[491] || (_cache[491] = _createElementVNode("span", null, "타(성매매)상담소", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '지원시설',
                                        onClick: _cache[144] || (_cache[144] = ($event: any) => ($setup.state.data.newInterventionMethod = '지원시설'))
                                      }, null, 8, _hoisted_305),
                                      _cache[492] || (_cache[492] = _createElementVNode("em", null, null, -1)),
                                      _cache[493] || (_cache[493] = _createElementVNode("span", null, "지원시설", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '공동생활가정',
                                        onClick: _cache[145] || (_cache[145] = ($event: any) => ($setup.state.data.newInterventionMethod = '공동생활가정'))
                                      }, null, 8, _hoisted_306),
                                      _cache[494] || (_cache[494] = _createElementVNode("em", null, null, -1)),
                                      _cache[495] || (_cache[495] = _createElementVNode("span", null, "공동생활가정", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '자활지원센터',
                                        onClick: _cache[146] || (_cache[146] = ($event: any) => ($setup.state.data.newInterventionMethod = '자활지원센터'))
                                      }, null, 8, _hoisted_307),
                                      _cache[496] || (_cache[496] = _createElementVNode("em", null, null, -1)),
                                      _cache[497] || (_cache[497] = _createElementVNode("span", null, "자활지원센터", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '직업훈련기관',
                                        onClick: _cache[147] || (_cache[147] = ($event: any) => ($setup.state.data.newInterventionMethod = '직업훈련기관'))
                                      }, null, 8, _hoisted_308),
                                      _cache[498] || (_cache[498] = _createElementVNode("em", null, null, -1)),
                                      _cache[499] || (_cache[499] = _createElementVNode("span", null, "직업훈련 알선기관", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '전문상담기관(성폭·가폭·장애인)',
                                        onClick: _cache[148] || (_cache[148] = ($event: any) => ($setup.state.data.newInterventionMethod = '전문상담기관(성폭·가폭·장애인)'))
                                      }, null, 8, _hoisted_309),
                                      _cache[500] || (_cache[500] = _createElementVNode("em", null, null, -1)),
                                      _cache[501] || (_cache[501] = _createElementVNode("span", null, "전문상담기관 (성폭·가폭·장애인 등)", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '대안교육위탁기관',
                                        onClick: _cache[149] || (_cache[149] = ($event: any) => ($setup.state.data.newInterventionMethod = '대안교육위탁기관'))
                                      }, null, 8, _hoisted_310),
                                      _cache[502] || (_cache[502] = _createElementVNode("em", null, null, -1)),
                                      _cache[503] || (_cache[503] = _createElementVNode("span", null, "대안교육위탁기관", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '일시쉼터',
                                        onClick: _cache[150] || (_cache[150] = ($event: any) => ($setup.state.data.newInterventionMethod = '일시쉼터'))
                                      }, null, 8, _hoisted_311),
                                      _cache[504] || (_cache[504] = _createElementVNode("em", null, null, -1)),
                                      _cache[505] || (_cache[505] = _createElementVNode("span", null, "일시쉼터", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: 
                                                                        $setup.state.data.newInterventionMethod === '개입방법/타기관의뢰/기관유형/기타'
                                                                    ,
                                        onClick: _cache[151] || (_cache[151] = ($event: any) => ($setup.state.data.newInterventionMethod = '개입방법/타기관의뢰/기관유형/기타'))
                                      }, null, 8, _hoisted_312),
                                      _cache[506] || (_cache[506] = _createElementVNode("em", null, null, -1)),
                                      _cache[507] || (_cache[507] = _createElementVNode("span", null, "기타", -1))
                                    ])
                                  ]),
                                  ($setup.state.data.newInterventionMethod === '개입방법/타기관의뢰/기관유형/기타')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_313, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": _cache[152] || (_cache[152] = ($event: any) => (($setup.state.data.newInterventionMethodOtherTxt) = $event))
                                        }, null, 512), [
                                          [_vModelText, $setup.state.data.newInterventionMethodOtherTxt]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              ($setup.state.data.newInterventionMethod === '전문상담기관(성폭·가폭·장애인)')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
                                    _cache[519] || (_cache[519] = _createElementVNode("div", { class: "area_col_head" }, [
                                      _createElementVNode("label", null, "[전문상담기관]")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_315, [
                                      _createElementVNode("div", _hoisted_316, [
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodProfessional",
                                            checked: $setup.state.data.newInterventionMethodProfessional === '성폭력',
                                            onClick: _cache[153] || (_cache[153] = ($event: any) => ($setup.state.data.newInterventionMethodProfessional = '성폭력'))
                                          }, null, 8, _hoisted_317),
                                          _cache[509] || (_cache[509] = _createElementVNode("em", null, null, -1)),
                                          _cache[510] || (_cache[510] = _createElementVNode("span", null, "성폭력", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodProfessional",
                                            checked: $setup.state.data.newInterventionMethodProfessional === '가정폭력',
                                            onClick: _cache[154] || (_cache[154] = ($event: any) => ($setup.state.data.newInterventionMethodProfessional = '가정폭력'))
                                          }, null, 8, _hoisted_318),
                                          _cache[511] || (_cache[511] = _createElementVNode("em", null, null, -1)),
                                          _cache[512] || (_cache[512] = _createElementVNode("span", null, "가정폭력", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodProfessional",
                                            checked: $setup.state.data.newInterventionMethodProfessional === '장애인',
                                            onClick: _cache[155] || (_cache[155] = ($event: any) => ($setup.state.data.newInterventionMethodProfessional = '장애인'))
                                          }, null, 8, _hoisted_319),
                                          _cache[513] || (_cache[513] = _createElementVNode("em", null, null, -1)),
                                          _cache[514] || (_cache[514] = _createElementVNode("span", null, "장애인", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodProfessional",
                                            checked: $setup.state.data.newInterventionMethodProfessional === '이주여성',
                                            onClick: _cache[156] || (_cache[156] = ($event: any) => ($setup.state.data.newInterventionMethodProfessional = '이주여성'))
                                          }, null, 8, _hoisted_320),
                                          _cache[515] || (_cache[515] = _createElementVNode("em", null, null, -1)),
                                          _cache[516] || (_cache[516] = _createElementVNode("span", null, "이주여성", -1))
                                        ]),
                                        _createElementVNode("label", null, [
                                          _createElementVNode("input", {
                                            type: "radio",
                                            name: "newInterventionMethodProfessional",
                                            checked: $setup.state.data.newInterventionMethodProfessional === '디지털성범죄',
                                            onClick: _cache[157] || (_cache[157] = ($event: any) => ($setup.state.data.newInterventionMethodProfessional = '디지털성범죄'))
                                          }, null, 8, _hoisted_321),
                                          _cache[517] || (_cache[517] = _createElementVNode("em", null, null, -1)),
                                          _cache[518] || (_cache[518] = _createElementVNode("span", null, "디지털성범죄", -1))
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_322, [
                                _cache[528] || (_cache[528] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[상담유형]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_323, [
                                  _createElementVNode("div", _hoisted_324, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethodOtherAdviceType",
                                        checked: $setup.state.data.newInterventionMethodOtherAdviceType === '의뢰상담',
                                        onClick: _cache[158] || (_cache[158] = ($event: any) => ($setup.state.data.newInterventionMethodOtherAdviceType = '의뢰상담'))
                                      }, null, 8, _hoisted_325),
                                      _cache[520] || (_cache[520] = _createElementVNode("em", null, null, -1)),
                                      _cache[521] || (_cache[521] = _createElementVNode("span", null, "의뢰상담", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethodOtherAdviceType",
                                        checked: $setup.state.data.newInterventionMethodOtherAdviceType === '모니터링 상담',
                                        onClick: _cache[159] || (_cache[159] = ($event: any) => ($setup.state.data.newInterventionMethodOtherAdviceType = '모니터링 상담'))
                                      }, null, 8, _hoisted_326),
                                      _cache[522] || (_cache[522] = _createElementVNode("em", null, null, -1)),
                                      _cache[523] || (_cache[523] = _createElementVNode("span", null, "모니터링 상담", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethodOtherAdviceType",
                                        checked: $setup.state.data.newInterventionMethodOtherAdviceType === '입소',
                                        onClick: _cache[160] || (_cache[160] = ($event: any) => ($setup.state.data.newInterventionMethodOtherAdviceType = '입소'))
                                      }, null, 8, _hoisted_327),
                                      _cache[524] || (_cache[524] = _createElementVNode("em", null, null, -1)),
                                      _cache[525] || (_cache[525] = _createElementVNode("span", null, "입소", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethodOtherAdviceType",
                                        checked: $setup.state.data.newInterventionMethodOtherAdviceType === '이용자등록',
                                        onClick: _cache[161] || (_cache[161] = ($event: any) => ($setup.state.data.newInterventionMethodOtherAdviceType = '이용자등록'))
                                      }, null, 8, _hoisted_328),
                                      _cache[526] || (_cache[526] = _createElementVNode("em", null, null, -1)),
                                      _cache[527] || (_cache[527] = _createElementVNode("span", null, "이용자 등록", -1))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.state.data.result === '기타')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_329, [
                          _cache[541] || (_cache[541] = _createElementVNode("div", { class: "area_col_head" }, [
                            _createElementVNode("label", null, "기타")
                          ], -1)),
                          _createElementVNode("div", _hoisted_330, [
                            _createElementVNode("div", _hoisted_331, [
                              _createElementVNode("div", _hoisted_332, [
                                _cache[540] || (_cache[540] = _createElementVNode("div", { class: "area_col_head" }, [
                                  _createElementVNode("label", null, "[기타]")
                                ], -1)),
                                _createElementVNode("div", _hoisted_333, [
                                  _createElementVNode("div", _hoisted_334, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '무응답',
                                        onClick: _cache[162] || (_cache[162] = ($event: any) => ($setup.state.data.newInterventionMethod = '무응답'))
                                      }, null, 8, _hoisted_335),
                                      _cache[530] || (_cache[530] = _createElementVNode("em", null, null, -1)),
                                      _cache[531] || (_cache[531] = _createElementVNode("span", null, "무응답", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '연락두절',
                                        onClick: _cache[163] || (_cache[163] = ($event: any) => ($setup.state.data.newInterventionMethod = '연락두절'))
                                      }, null, 8, _hoisted_336),
                                      _cache[532] || (_cache[532] = _createElementVNode("em", null, null, -1)),
                                      _cache[533] || (_cache[533] = _createElementVNode("span", null, "연락두절", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '통화거절',
                                        onClick: _cache[164] || (_cache[164] = ($event: any) => ($setup.state.data.newInterventionMethod = '통화거절'))
                                      }, null, 8, _hoisted_337),
                                      _cache[534] || (_cache[534] = _createElementVNode("em", null, null, -1)),
                                      _cache[535] || (_cache[535] = _createElementVNode("span", null, "통화거절", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '행정',
                                        onClick: _cache[165] || (_cache[165] = ($event: any) => ($setup.state.data.newInterventionMethod = '행정'))
                                      }, null, 8, _hoisted_338),
                                      _cache[536] || (_cache[536] = _createElementVNode("em", null, null, -1)),
                                      _cache[537] || (_cache[537] = _createElementVNode("span", null, "행정", -1))
                                    ]),
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        name: "newInterventionMethod",
                                        checked: $setup.state.data.newInterventionMethod === '종결',
                                        onClick: _cache[166] || (_cache[166] = ($event: any) => ($setup.state.data.newInterventionMethod = '종결'))
                                      }, null, 8, _hoisted_339),
                                      _cache[538] || (_cache[538] = _createElementVNode("em", null, null, -1)),
                                      _cache[539] || (_cache[539] = _createElementVNode("span", null, "종결", -1))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_340, [
                  _cache[600] || (_cache[600] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "8. 성과현황")
                  ], -1)),
                  _createElementVNode("div", _hoisted_341, [
                    _createElementVNode("div", _hoisted_342, [
                      _createElementVNode("div", _hoisted_343, [
                        _createElementVNode("div", _hoisted_344, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessState === 1,
                              onClick: _cache[167] || (_cache[167] = ($event: any) => ($setup.state.data.newSuccessState ^= 1))
                            }, null, 8, _hoisted_345),
                            _cache[543] || (_cache[543] = _createElementVNode("em", null, null, -1)),
                            _cache[544] || (_cache[544] = _createElementVNode("span", null, "※ 성과 현황 입력시 체크 바랍니다.", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_346, [
                      _cache[551] || (_cache[551] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "[의료지원]")
                      ], -1)),
                      _createElementVNode("div", _hoisted_347, [
                        _createElementVNode("div", _hoisted_348, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessMonthMedicalTreatmentStop === '치료중단',
                              onClick: _cache[168] || (_cache[168] = ($event: any) => (
                                                            $setup.state.data.newSuccessMonthMedicalTreatmentStop =
                                                                $setup.state.data.newSuccessMonthMedicalTreatmentStop === '치료중단' ? '' : '치료중단'
                                                        ))
                            }, null, 8, _hoisted_349),
                            _cache[545] || (_cache[545] = _createElementVNode("em", null, null, -1)),
                            _cache[546] || (_cache[546] = _createElementVNode("span", null, "치료중단", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_350, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessMonthMedicalTreatmentIng === '치료중',
                              onClick: _cache[169] || (_cache[169] = ($event: any) => (
                                                            $setup.state.data.newSuccessMonthMedicalTreatmentIng =
                                                                $setup.state.data.newSuccessMonthMedicalTreatmentIng === '치료중' ? '' : '치료중'
                                                        ))
                            }, null, 8, _hoisted_351),
                            _cache[547] || (_cache[547] = _createElementVNode("em", null, null, -1)),
                            _cache[548] || (_cache[548] = _createElementVNode("span", null, "치료중", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_352, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessMonthMedicalTreatmentCompleteControl === '완치/증상조절',
                              onClick: _cache[170] || (_cache[170] = ($event: any) => (
                                                            $setup.state.data.newSuccessMonthMedicalTreatmentCompleteControl =
                                                                $setup.state.data.newSuccessMonthMedicalTreatmentCompleteControl === '완치/증상조절'
                                                                    ? ''
                                                                    : '완치/증상조절'
                                                        ))
                            }, null, 8, _hoisted_353),
                            _cache[549] || (_cache[549] = _createElementVNode("em", null, null, -1)),
                            _cache[550] || (_cache[550] = _createElementVNode("span", null, "완치/증상조절", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_354, [
                      _cache[564] || (_cache[564] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "[법률지원]")
                      ], -1)),
                      _createElementVNode("div", _hoisted_355, [
                        _createElementVNode("div", _hoisted_356, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessMonthLawasWin === '승소',
                              onClick: _cache[171] || (_cache[171] = ($event: any) => (
                                                            $setup.state.data.newSuccessMonthLawasWin =
                                                                $setup.state.data.newSuccessMonthLawasWin === '승소' ? '' : '승소'
                                                        ))
                            }, null, 8, _hoisted_357),
                            _cache[552] || (_cache[552] = _createElementVNode("em", null, null, -1)),
                            _cache[553] || (_cache[553] = _createElementVNode("span", null, "승소", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_358, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessMonthLawasLose === '패소',
                              onClick: _cache[172] || (_cache[172] = ($event: any) => (
                                                            $setup.state.data.newSuccessMonthLawasLose =
                                                                $setup.state.data.newSuccessMonthLawasLose === '패소' ? '' : '패소'
                                                        ))
                            }, null, 8, _hoisted_359),
                            _cache[554] || (_cache[554] = _createElementVNode("em", null, null, -1)),
                            _cache[555] || (_cache[555] = _createElementVNode("span", null, "패소", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_360, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessMonthLawasProtective === '보호처분',
                              onClick: _cache[173] || (_cache[173] = ($event: any) => (
                                                            $setup.state.data.newSuccessMonthLawasProtective =
                                                                $setup.state.data.newSuccessMonthLawasProtective === '보호처분' ? '' : '보호처분'
                                                        ))
                            }, null, 8, _hoisted_361),
                            _cache[556] || (_cache[556] = _createElementVNode("em", null, null, -1)),
                            _cache[557] || (_cache[557] = _createElementVNode("span", null, "보호처분", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_362, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessMonthLawasBankruptcyDishonestly === '파산/면책결정',
                              onClick: _cache[174] || (_cache[174] = ($event: any) => (
                                                            $setup.state.data.newSuccessMonthLawasBankruptcyDishonestly =
                                                                $setup.state.data.newSuccessMonthLawasBankruptcyDishonestly === '파산/면책결정'
                                                                    ? ''
                                                                    : '파산/면책결정'
                                                        ))
                            }, null, 8, _hoisted_363),
                            _cache[558] || (_cache[558] = _createElementVNode("em", null, null, -1)),
                            _cache[559] || (_cache[559] = _createElementVNode("span", null, "파산/면책결정", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_364, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessMonthLawasMediation === '조정/합의',
                              onClick: _cache[175] || (_cache[175] = ($event: any) => (
                                                            $setup.state.data.newSuccessMonthLawasMediation =
                                                                $setup.state.data.newSuccessMonthLawasMediation === '조정/합의' ? '' : '조정/합의'
                                                        ))
                            }, null, 8, _hoisted_365),
                            _cache[560] || (_cache[560] = _createElementVNode("em", null, null, -1)),
                            _cache[561] || (_cache[561] = _createElementVNode("span", null, "조정/합의", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_366, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: $setup.state.data.newSuccessMonthLawasDefer === '잠정보류',
                              onClick: _cache[176] || (_cache[176] = ($event: any) => (
                                                            $setup.state.data.newSuccessMonthLawasDefer =
                                                                $setup.state.data.newSuccessMonthLawasDefer === '잠정보류' ? '' : '잠정보류'
                                                        ))
                            }, null, 8, _hoisted_367),
                            _cache[562] || (_cache[562] = _createElementVNode("em", null, null, -1)),
                            _cache[563] || (_cache[563] = _createElementVNode("span", null, "잠정보류", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_368, [
                      _cache[599] || (_cache[599] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "[자활지원]")
                      ], -1)),
                      _createElementVNode("div", _hoisted_369, [
                        _createElementVNode("div", _hoisted_370, [
                          _createElementVNode("div", _hoisted_371, [
                            _cache[587] || (_cache[587] = _createElementVNode("div", { class: "area_col_head" }, [
                              _createElementVNode("label", null, "※취업 및 진학 현황")
                            ], -1)),
                            _createElementVNode("div", _hoisted_372, [
                              _createElementVNode("div", _hoisted_373, [
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    name: "newSuccessMonthJawhalJobService",
                                    checked: $setup.state.data.newSuccessMonthJawhalJobService === '서비스업',
                                    onClick: _cache[177] || (_cache[177] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalJobService =
                                                                            $setup.state.data.newSuccessMonthJawhalJobService === '서비스업'
                                                                                ? ''
                                                                                : '서비스업'
                                                                    ))
                                  }, null, 8, _hoisted_374),
                                  _cache[565] || (_cache[565] = _createElementVNode("em", null, null, -1)),
                                  _cache[566] || (_cache[566] = _createElementVNode("span", null, "서비스업", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    name: "newSuccessMonthJawhalJobWorker",
                                    checked: $setup.state.data.newSuccessMonthJawhalJobWorker === '생산직',
                                    onClick: _cache[178] || (_cache[178] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalJobWorker =
                                                                            $setup.state.data.newSuccessMonthJawhalJobWorker === '생산직' ? '' : '생산직'
                                                                    ))
                                  }, null, 8, _hoisted_375),
                                  _cache[567] || (_cache[567] = _createElementVNode("em", null, null, -1)),
                                  _cache[568] || (_cache[568] = _createElementVNode("span", null, "생산직", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalOfficejob === '사무직',
                                    onClick: _cache[179] || (_cache[179] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalOfficejob =
                                                                            $setup.state.data.newSuccessMonthJawhalOfficejob === '사무직' ? '' : '사무직'
                                                                    ))
                                  }, null, 8, _hoisted_376),
                                  _cache[569] || (_cache[569] = _createElementVNode("em", null, null, -1)),
                                  _cache[570] || (_cache[570] = _createElementVNode("span", null, "사무직", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalSuppasOwnbusi === '창업',
                                    onClick: _cache[180] || (_cache[180] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalSuppasOwnbusi =
                                                                            $setup.state.data.newSuccessMonthJawhalSuppasOwnbusi === '창업' ? '' : '창업'
                                                                    ))
                                  }, null, 8, _hoisted_377),
                                  _cache[571] || (_cache[571] = _createElementVNode("em", null, null, -1)),
                                  _cache[572] || (_cache[572] = _createElementVNode("span", null, "창업", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalSuppasUniv === '진학',
                                    onClick: _cache[181] || (_cache[181] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalSuppasUniv =
                                                                            $setup.state.data.newSuccessMonthJawhalSuppasUniv === '진학' ? '' : '진학'
                                                                    ))
                                  }, null, 8, _hoisted_378),
                                  _cache[573] || (_cache[573] = _createElementVNode("em", null, null, -1)),
                                  _cache[574] || (_cache[574] = _createElementVNode("span", null, "진학", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalSuppasCerti === '자격증취득',
                                    onClick: _cache[182] || (_cache[182] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalSuppasCerti =
                                                                            $setup.state.data.newSuccessMonthJawhalSuppasCerti === '자격증취득'
                                                                                ? ''
                                                                                : '자격증취득'
                                                                    ))
                                  }, null, 8, _hoisted_379),
                                  _cache[575] || (_cache[575] = _createElementVNode("em", null, null, -1)),
                                  _cache[576] || (_cache[576] = _createElementVNode("span", null, "자격증 취득", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: 
                                                                        $setup.state.data.newSuccessMonthJawhalCertificateExamination === '검정고시합격'
                                                                    ,
                                    onClick: _cache[183] || (_cache[183] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalCertificateExamination =
                                                                            $setup.state.data.newSuccessMonthJawhalCertificateExamination === '검정고시합격'
                                                                                ? ''
                                                                                : '검정고시합격'
                                                                    ))
                                  }, null, 8, _hoisted_380),
                                  _cache[577] || (_cache[577] = _createElementVNode("em", null, null, -1)),
                                  _cache[578] || (_cache[578] = _createElementVNode("span", null, "검정고시 합격", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalHighdegreeGet === '상위학위취득',
                                    onClick: _cache[184] || (_cache[184] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalHighdegreeGet =
                                                                            $setup.state.data.newSuccessMonthJawhalHighdegreeGet === '상위학위취득'
                                                                                ? ''
                                                                                : '상위학위취득'
                                                                    ))
                                  }, null, 8, _hoisted_381),
                                  _cache[579] || (_cache[579] = _createElementVNode("em", null, null, -1)),
                                  _cache[580] || (_cache[580] = _createElementVNode("span", null, "상위학위 취득", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalRegisterSchool === '학원등록',
                                    onClick: _cache[185] || (_cache[185] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalRegisterSchool =
                                                                            $setup.state.data.newSuccessMonthJawhalRegisterSchool === '학원등록'
                                                                                ? ''
                                                                                : '학원등록'
                                                                    ))
                                  }, null, 8, _hoisted_382),
                                  _cache[581] || (_cache[581] = _createElementVNode("em", null, null, -1)),
                                  _cache[582] || (_cache[582] = _createElementVNode("span", null, "학원등록", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalLevelup === '진급',
                                    onClick: _cache[186] || (_cache[186] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalLevelup =
                                                                            $setup.state.data.newSuccessMonthJawhalLevelup === '진급' ? '' : '진급'
                                                                    ))
                                  }, null, 8, _hoisted_383),
                                  _cache[583] || (_cache[583] = _createElementVNode("em", null, null, -1)),
                                  _cache[584] || (_cache[584] = _createElementVNode("span", null, "진급", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalEtc === '기타',
                                    onClick: _cache[187] || (_cache[187] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalEtc =
                                                                            $setup.state.data.newSuccessMonthJawhalEtc === '기타' ? '' : '기타'
                                                                    ))
                                  }, null, 8, _hoisted_384),
                                  _cache[585] || (_cache[585] = _createElementVNode("em", null, null, -1)),
                                  _cache[586] || (_cache[586] = _createElementVNode("span", null, "기타", -1))
                                ])
                              ]),
                              ($setup.state.data.newSuccessMonthJawhalEtc === '기타')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_385, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[188] || (_cache[188] = ($event: any) => (($setup.state.data.newSuccessMonthJawhalEtcTxt) = $event))
                                    }, null, 512), [
                                      [_vModelText, $setup.state.data.newSuccessMonthJawhalEtcTxt]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_386, [
                            _cache[598] || (_cache[598] = _createElementVNode("div", { class: "area_col_head" }, [
                              _createElementVNode("label", null, "※고용형태")
                            ], -1)),
                            _createElementVNode("div", _hoisted_387, [
                              _createElementVNode("div", _hoisted_388, [
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalJobRegular === '정규직',
                                    onClick: _cache[189] || (_cache[189] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalJobRegular =
                                                                            $setup.state.data.newSuccessMonthJawhalJobRegular === '정규직' ? '' : '정규직'
                                                                    ))
                                  }, null, 8, _hoisted_389),
                                  _cache[588] || (_cache[588] = _createElementVNode("em", null, null, -1)),
                                  _cache[589] || (_cache[589] = _createElementVNode("span", null, "정규직", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalJobNonRegular === '비정규직',
                                    onClick: _cache[190] || (_cache[190] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalJobNonRegular =
                                                                            $setup.state.data.newSuccessMonthJawhalJobNonRegular === '비정규직'
                                                                                ? ''
                                                                                : '비정규직'
                                                                    ))
                                  }, null, 8, _hoisted_390),
                                  _cache[590] || (_cache[590] = _createElementVNode("em", null, null, -1)),
                                  _cache[591] || (_cache[591] = _createElementVNode("span", null, "비정규직", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalJobIntern === '인턴,실습',
                                    onClick: _cache[191] || (_cache[191] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalJobIntern =
                                                                            $setup.state.data.newSuccessMonthJawhalJobIntern === '인턴,실습'
                                                                                ? ''
                                                                                : '인턴,실습'
                                                                    ))
                                  }, null, 8, _hoisted_391),
                                  _cache[592] || (_cache[592] = _createElementVNode("em", null, null, -1)),
                                  _cache[593] || (_cache[593] = _createElementVNode("span", null, "인턴,실습", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalJobDaily === '단기근로자',
                                    onClick: _cache[192] || (_cache[192] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalJobDaily =
                                                                            $setup.state.data.newSuccessMonthJawhalJobDaily === '단기근로자'
                                                                                ? ''
                                                                                : '단기근로자'
                                                                    ))
                                  }, null, 8, _hoisted_392),
                                  _cache[594] || (_cache[594] = _createElementVNode("em", null, null, -1)),
                                  _cache[595] || (_cache[595] = _createElementVNode("span", null, "단기근로자", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: $setup.state.data.newSuccessMonthJawhalJobEtc === '기타',
                                    onClick: _cache[193] || (_cache[193] = ($event: any) => (
                                                                        $setup.state.data.newSuccessMonthJawhalJobEtc =
                                                                            $setup.state.data.newSuccessMonthJawhalJobEtc === '기타' ? '' : '기타'
                                                                    ))
                                  }, null, 8, _hoisted_393),
                                  _cache[596] || (_cache[596] = _createElementVNode("em", null, null, -1)),
                                  _cache[597] || (_cache[597] = _createElementVNode("span", null, "기타", -1))
                                ])
                              ]),
                              ($setup.state.data.newSuccessMonthJawhalJobEtc === '기타')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_394, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[194] || (_cache[194] = ($event: any) => (($setup.state.data.newSuccessMonthJawhalJobEtcTxt) = $event))
                                    }, null, 512), [
                                      [_vModelText, $setup.state.data.newSuccessMonthJawhalJobEtcTxt]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_395, [
                  _cache[601] || (_cache[601] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, [
                      _createTextVNode(" 9. 상담원 종합의견 / "),
                      _createElementVNode("br"),
                      _createTextVNode(" 추후 계획 ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_396, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[195] || (_cache[195] = ($event: any) => (($setup.state.data.counselDetailVO.newCounselorDesc) = $event))
                    }, null, 512), [
                      [_vModelText, $setup.state.data.counselDetailVO.newCounselorDesc]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_397, [
            _createElementVNode("div", _hoisted_398, [
              _createElementVNode("div", _hoisted_399, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[196] || (_cache[196] = ($event: any) => ($setup.router.push({ name: 'counsel' })))
                }, "상담목록 가기"),
                _createElementVNode("button", {
                  type: "button",
                  class: "active",
                  onClick: _cache[197] || (_cache[197] = 
//@ts-ignore
(...args) => ($setup.confirmAdd && $setup.confirmAdd(...args)))
                }, "등록"),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[198] || (_cache[198] = 
//@ts-ignore
(...args) => ($setup.reset && $setup.reset(...args)))
                }, "다시작성")
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowFindClient)
      ? (_openBlock(), _createBlock(_component_FindClient, {
          key: 1,
          onClose: _cache[199] || (_cache[199] = ($event: any) => ($setup.state.isShowFindClient = false)),
          onCallback: $setup.appendClientList,
          onCallback2: $setup.appendClient
        }, null, 8, ["onCallback", "onCallback2"]))
      : _createCommentVNode("", true)
  ], 64))
}